<template>
  <div class="cuttingtop">
    <div class="cuttings">
      <div class="top_input flex">
        <div class="unmaeinput">
          <el-input
            style="height: 55px"
            clearable
            placeholder="搜索您想要的行业/品牌"
            v-model="value"
            @input="unames"
            @blur="cnames"
            @focus="bnames"
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </div>
      </div>
      <div class="top_input_list ru5 baff" v-if="searchStuts">
        <div v-if="usnameList.length">
          <div
            class="list cursor"
            v-for="(item, indexr) in usnameList"
            :key="indexr"
            @click="searchscli(item)"
          >
            <div class="contern">
              {{ item.name }}
              <span class="sz12" v-if="item.type === 'industry'">行业</span>
              <span class="sz12" v-if="item.type === 'brand'">品牌</span>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="list cursor center">
            <div class="contern">数据正在更新中，敬请期待。</div>
          </div>
        </div>
      </div>
      <div class="top_center">
        <div class="cutting" id="industrys">
          <!-- 洞察情报 -->
          <div class="tbpage flex">
            <div
              class="center cursor"
              :class="tabStuts == 1 ? 'tbpage_bag' : ''"
              @click="tabclick(1)"
            >
              行业洞察
            </div>
            <div
              class="center cursor"
              :class="tabStuts == 2 ? 'tbpage_bag' : ''"
              @click="tabclick(2)"
            >
              品牌情报
            </div>
          </div>
          <div v-show="tabStuts == 1">
            <div class="industry">
              <div class="industry_tit sz16 font_bo">行业：</div>
              <div class="flex industry_titlist">
                <div
                  class="industry_list center cursor sz14"
                  v-for="(item, index) in industryList"
                  :key="index"
                  :class="industryStuts == index ? 'industrybag' : ''"
                  @click="industryClck(item, index)"
                >
                  {{ item.bigIndustryName }}
                </div>
              </div>
            </div>
            <div class="tit_bt">
              <span class="font_bo sz18">标杆品牌</span>
            </div>
            <div class="tit_bt_identification flex">
              <p
                class="question ru50 center cursor"
                @mouseenter="mouseover"
                @mouseleave="mouseout"
              >
                ?
              </p>
              <p class="sz12 text" v-if="dialogVisible">
                佣金比例，EPC，Cookies均为预估值
              </p>
            </div>
            <div class="carouselpp">
              <el-carousel
                ref="cardShow"
                indicator-position="outside"
                :autoplay="false"
                arrow="never"
                trigger="click"
              >
                <el-carousel-item>
                  <div class="itemswpe flex">
                    <div
                      class="item_list"
                      v-for="(item, index) in biaoBrandList1"
                      :key="item.brandCode"
                    >
                      <div class="item_list_img" v-if="item.brandCode">
                        <el-image :src="item.domain"> </el-image>
                      </div>
                      <div class="item_conten" v-if="item.brandCode">
                        <div class="item_tit flex">
                          <div class="item_tit_text">
                            {{ item.brandName }}
                            <span class="sz12">
                              {{ item.countryname }}
                            </span>
                          </div>
                        </div>
                        <div class="item_conten_zb flex">
                          <div class="item_conten_one">
                            <span class="sz14 font_r">佣金比例</span>&nbsp;
                            <span class="sz14 co6e font_r">
                              {{
                                item.commissionRate ? item.commissionRate : ''
                              }}
                            </span>
                          </div>
                          <div class="item_conten_two">
                            <span class="sz14 font_r">EPC</span>&nbsp;
                            <span class="sz14 co6e font_r">
                              {{ item.epc }}
                            </span>
                          </div>
                          <div>
                            <span class="sz14 font_r">Cookies</span>&nbsp;
                            <span class="sz14 co6e font_r">
                              {{ item.cookiesDay }}天
                            </span>
                          </div>
                        </div>
                        <div class="item_type sz14 font_r">联盟客类型</div>
                        <div class="Charthy">
                          <div
                            :id="'myChart' + index"
                            :style="{ width: '100%', height: '100%' }"
                          ></div>
                        </div>
                        <div class="flex ptlist">
                          <div class="ptlist_title sz14 font_r">联盟平台</div>
                          <div class="imglist flex">
                            <div
                              v-for="(
                                item, index3
                              ) in item.allianceGuestPlatformLogosList"
                              :key="index3"
                            >
                              <img :src="item" alt />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-carousel-item>
                <el-carousel-item v-if="biaoBrandList2.length">
                  <div class="itemswpe flex">
                    <div
                      class="item_list"
                      v-for="(item, index) in biaoBrandList2"
                      :key="item.brandCode"
                    >
                      <div class="item_list_img" v-if="item.brandCode">
                        <img :src="item.domain" alt />
                      </div>
                      <div class="item_conten" v-if="item.brandCode">
                        <div class="item_tit flex">
                          <div class="item_tit_text">
                            {{ item.brandName }}
                            <span class="sz12">
                              {{ item.countryname }}
                            </span>
                          </div>
                        </div>
                        <div class="item_conten_zb flex">
                          <div class="item_conten_one">
                            <span class="sz14 font_r">佣金比例</span>&nbsp;
                            <span class="sz14 co6e font_r">
                              {{
                                item.commissionRate ? item.commissionRate : ''
                              }}
                            </span>
                          </div>
                          <div class="item_conten_two">
                            <span class="sz14 font_r">EPC</span>&nbsp;
                            <span class="sz14 co6e font_r">
                              {{ item.epc }}
                            </span>
                          </div>
                          <div>
                            <span class="sz14 font_r">Cookies</span>&nbsp;
                            <span class="sz14 co6e font_r">
                              {{ item.cookiesDay }}天
                            </span>
                          </div>
                        </div>
                        <div class="item_type sz14 font_r">联盟客类型</div>
                        <div class="Charthy">
                          <div
                            :id="'myChart' + (index + 3)"
                            :style="{ width: '100%', height: '100%' }"
                          ></div>
                        </div>
                        <div class="flex ptlist">
                          <div class="ptlist_title sz14 font_r">联盟平台</div>
                          <div class="imglist flex">
                            <div
                              v-for="(
                                item, index3
                              ) in item.allianceGuestPlatformLogosList"
                              :key="index3"
                            >
                              <img :src="item" alt />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-carousel-item>
              </el-carousel>
              <div class="switchel flex">
                <template v-if="biaoBrandList2.length">
                  <div class="sz30" :class="carstuts == 1 ? 'co6e' : 'coco'">
                    <i
                      class="el-icon-caret-left cursor"
                      @click="arrowClick('left')"
                    ></i>
                  </div>
                  <div class="sz30" :class="carstuts == 2 ? 'co6e' : 'coco'">
                    <i
                      class="el-icon-caret-right cursor"
                      @click="arrowClicktwo('right')"
                    ></i>
                  </div>
                </template>
              </div>
            </div>
            <div class="center_tit flex">
              <div class="font_bo text">联盟客详情</div>
              <div class="cent_input">
                <el-input
                  placeholder="请输入联盟客或网站名称"
                  @keyup.enter.native="nameclick(1)"
                  clearable
                  v-model="aname"
                ></el-input>
                <div class="icons">
                  <img src="../../assets/img/foll/search.png" alt />
                </div>
              </div>
              <div
                class="searchname ru5 center ba6e coff cursor sz16"
                @click="nameclick(1)"
              >
                搜索
              </div>
            </div>
            <div class="center_tit_con">
              <div style="min-height: 40px" class="center_tit_gj bord">
                <div class="center_tit_let">
                  <div class="co6e">国家/地区</div>
                  <div class="cursor allgj" @click="all(0)">
                    <p :class="countryListStuts == -1 ? 'tit_lrestus' : ''">
                      全部
                    </p>
                  </div>
                </div>
                <div
                  class="center_tit_lre"
                  :class="feed == true ? 'center_stuts' : ''"
                >
                  <div
                    class="center"
                    v-for="(item, index4) in countryListTwo"
                    :key="index4"
                    @click="titLrestus(item, index4)"
                  >
                    <p :class="countryListStuts == index4 ? 'tit_lrestus' : ''">
                      {{ item.value }}
                    </p>
                  </div>
                </div>
                <div
                  class="center_tit_rig cursor"
                  v-if="countryListTwo.length > 7"
                >
                  <div v-if="!feed" @click="feedtype(1)">
                    <p>
                      展开
                      <i class="el-icon-caret-bottom"></i>
                    </p>
                  </div>
                  <div v-else @click="feedtype(2)">
                    <p>
                      收起
                      <i class="el-icon-caret-top"></i>
                    </p>
                  </div>
                </div>
                <div class="center_tit_rig" v-else></div>
              </div>
              <div class="center_tit_gj bord">
                <div class="center_tit_let">
                  <div class="co6e">类型</div>
                  <div class="cursor allgj" @click="all(1)">
                    <p :class="countryListStutstwo == -1 ? 'tit_lrestus' : ''">
                      全部
                    </p>
                  </div>
                </div>
                <div
                  class="center_tit_lre"
                  :class="feedTwo == true ? 'center_stuts' : ''"
                >
                  <div
                    class="center"
                    v-for="(item, index7) in typeListTwo"
                    :key="index7"
                    @click="titLrestusTwo(item, index7)"
                  >
                    <p
                      :class="
                        countryListStutstwo == index7 ? 'tit_lrestus' : ''
                      "
                    >
                      {{ item.value }}
                    </p>
                  </div>
                </div>
                <div
                  class="center_tit_rig cursor"
                  v-if="typeListTwo.length > 7"
                >
                  <div v-if="!feedTwo" @click="feedtypetwo(1)">
                    <p>
                      展开
                      <i class="el-icon-caret-bottom"></i>
                    </p>
                  </div>
                  <div v-else @click="feedtypetwo(2)">
                    <p>
                      收起
                      <i class="el-icon-caret-top"></i>
                    </p>
                  </div>
                </div>
                <div class="center_tit_rig" v-else></div>
              </div>
              <div class="center_tit_gj">
                <div class="center_tit_let">
                  <div class="co6e">平台</div>
                  <div class="cursor allgj" @click="all(2)">
                    <p :class="countryListStutsshr == -1 ? 'tit_lrestus' : ''">
                      全部
                    </p>
                  </div>
                </div>
                <div
                  class="center_tit_lre"
                  :class="feedsher == true ? 'center_stuts' : ''"
                >
                  <div
                    class="center"
                    v-for="(item, index8) in screenListTwo"
                    :key="index8"
                    @click="titLrestusShr(item, index8, 2)"
                  >
                    <p
                      :class="
                        countryListStutsshr == index8 ? 'tit_lrestus' : ''
                      "
                    >
                      {{ item.value }}
                    </p>
                  </div>
                </div>
                <div
                  class="center_tit_rig cursor"
                  v-if="screenListTwo.length > 7"
                >
                  <div v-if="!feedsher" @click="feedtypesher(1)">
                    <p>
                      展开
                      <i class="el-icon-caret-bottom"></i>
                    </p>
                  </div>
                  <div v-else @click="feedtypesher(2)">
                    <p>
                      收起
                      <i class="el-icon-caret-top"></i>
                    </p>
                  </div>
                </div>
                <div class="center_tit_rig" v-else></div>
              </div>
            </div>
            <div class="topArea">
              <el-radio-group v-model="orderRule" style @change="changeSort">
                <el-radio-button label="default">推荐 ❀</el-radio-button>
                <el-radio-button label="fans">
                  粉丝数
                  <span
                    style="display: inline-block; transform: translateY(-2px)"
                    >↓</span
                  >
                </el-radio-button>
                <el-radio-button label="newJoin">
                  发现时间
                  <span
                    style="display: inline-block; transform: translateY(-2px)"
                    >↓</span
                  >
                </el-radio-button>
              </el-radio-group>
              <el-checkbox-group
                v-model="havaEmail1"
                size="medium"
                @change="changeEmail1"
              >
                <el-checkbox-button style="display: flex" label="邮箱" key="1"
                  >{{ havaEmail1 ? '邮箱' : '全部' }} ✉</el-checkbox-button
                >
              </el-checkbox-group>

              <!-- <div class="email">
                <el-tooltip
                  v-if="havaEmail == ''"
                  class="item"
                  effect="dark"
                  content="仅有邮箱"
                  placement="bottom"
                >
                  <img src="@/assets/img/home/eml1.png" @click="changeEmail(1)" alt />
                </el-tooltip>
                <el-tooltip v-else class="item" effect="dark" content="全部" placement="bottom">
                  <img src="@/assets/img/home/eml.png" @click="changeEmail(1)" alt />
                </el-tooltip>
              </div>-->
              <!-- <Pagination
                :pageNo="currentPage"
                :pageSize="size"
                :total="total"
                :continues="4"
                @getPageNo="currentchange"
              />-->
            </div>
            <div
              v-if="brandsList.length"
              element-loading-spinner="el-icon-loading"
            >
              <div
                class="detali flex detaliTwo alcen"
                v-for="(item, index5) in brandsList"
                :key="item.allianceCode"
                :class="detaliStuts == index5 ? 'detaliTwo' : ''"
                @click="detaliqx(index5)"
              >
                <div class="detali_let flex box alcen">
                  <div class="hotbq sz30 co6e font_a" v-if="item.tagNew">
                    NEW!
                  </div>
                  <div class="hotbq sz30 co6e font_a" v-else-if="item.tagHot">
                    HOT!
                  </div>
                  <div
                    class="hotbq sz30 co6e font_a"
                    v-else-if="item.tagActive"
                  >
                    ACTIVE!
                  </div>
                  <div class="detali_let_one flex">
                    <div class="detali_let_one_img cursor">
                      <img
                        v-if="item.headSrc"
                        :src="item.headSrc"
                        alt="headImg"
                        :class="item.allianceCode"
                        @click="godetil(item)"
                      />
                      <img
                        v-else
                        src="@/assets/img/default.png"
                        alt
                        @click="godetil(item)"
                      />
                    </div>
                  </div>
                  <div class="category">
                    <div class="flex mb6 alcen mt8">
                      <p
                        class="let_one_p_name mr10 cursor font_bo"
                        @click="godetil(item)"
                      >
                        {{ item.name }}
                      </p>
                      <p class="let_one_p_gj sz12">{{ item.countryName }}</p>
                    </div>
                    <div class="flex mb6">
                      <p class="sz12 labelbox h25">行业</p>
                      <div v-if="item.types" class="foll_title">
                        <div class="foll_tt_top">
                          <p
                            class="foll_tt baffeef5 center ru5 sz12"
                            v-for="(ittr, index17) in item.types"
                            :key="index17"
                            v-show="index17 < 3"
                          >
                            {{ ittr }}
                          </p>
                          <el-tooltip
                            class="item"
                            effect="dark"
                            placement="right"
                            v-if="item.types.length > 3"
                          >
                            <div slot="content" class="foll_tt_d flex">
                              <p
                                class="mb8 mr10 coff"
                                v-for="(ittr, index16) in item.types"
                                :key="index16"
                              >
                                {{ ittr }}
                              </p>
                            </div>
                            <p
                              class="cursor"
                              style="width: 20px"
                              v-show="item.types.length > 3"
                            >
                              ...
                            </p>
                          </el-tooltip>
                        </div>
                      </div>
                    </div>
                    <div class="flex mb6">
                      <p class="sz12 labelbox h25">类型</p>
                      <div v-if="item.promoType" class="foll_title">
                        <div class="foll_tt_top">
                          <p
                            class="foll_tt baffeef5 center ru5 sz12"
                            v-for="(ittr, index17) in item.promoType"
                            :key="index17"
                            v-show="index17 < 3"
                          >
                            {{ ittr }}
                          </p>
                          <el-tooltip
                            class="item"
                            effect="dark"
                            placement="right"
                            v-if="item.promoType.length > 3"
                          >
                            <div slot="content" class="foll_tt_d flex">
                              <p
                                class="mb8 mr10 coff"
                                v-for="(ittr, index16) in item.promoType"
                                :key="index16"
                              >
                                {{ ittr }}
                              </p>
                            </div>
                            <p
                              class="cursor"
                              style="width: 20px"
                              v-show="item.promoType.length > 3"
                            >
                              ...
                            </p>
                          </el-tooltip>
                        </div>
                      </div>
                    </div>
                    <div class="flex mb6">
                      <p class="sz12 labelbox h25">品牌</p>
                      <div v-if="item.brands" class="foll_title">
                        <p
                          class="foll_tt ttres baffeef5 center ru5 sz12"
                          v-for="(ittr, index19) in item.brands"
                          :key="index19"
                          v-show="index19 < 3"
                        >
                          {{ ittr }}
                        </p>
                        <el-tooltip
                          class="item"
                          effect="dark"
                          placement="right"
                          v-if="item.brands.length > 3"
                        >
                          <div slot="content" class="foll_tt_d flex">
                            <p
                              class="mb8 mr10 coff"
                              v-for="(ittr, index18) in item.brands"
                              :key="index18"
                            >
                              {{ ittr }}
                            </p>
                          </div>
                          <p
                            class="cursor"
                            style="width: 20px"
                            v-show="item.brands.length > 2"
                          >
                            ...
                          </p>
                        </el-tooltip>
                      </div>
                    </div>
                    <div v-if="item.category" class="flex mb6">
                      <p class="sz12 labelbox h25">分类</p>
                      <div class="foll_title">
                        <div class="foll_tt_top">
                          <p
                            class="foll_tt baffeef5 center ru5 sz12 ttres"
                            v-for="(ittr, index17) in item.category"
                            :key="index17"
                            v-show="index17 < 3"
                          >
                            {{ ittr }}
                          </p>
                          <el-tooltip
                            class="item"
                            effect="dark"
                            placement="right"
                            v-if="item.category.length > 3"
                          >
                            <div slot="content" class="foll_tt_d flex">
                              <p
                                class="mb8 mr10 coff"
                                v-for="(ittr, index16) in item.category"
                                :key="index16"
                              >
                                {{ ittr }}
                              </p>
                            </div>
                            <p
                              class="cursor"
                              style="width: 20px"
                              v-show="item.category.length > 3"
                            >
                              ...
                            </p>
                          </el-tooltip>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="detali_cont boxz">
                  <div class="mb8">
                    <p class="sz12 titnames mb8 mt8">联盟平台</p>
                    <div
                      class="foll_title_top"
                      v-if="item.affiliateNetworkLogos"
                    >
                      <div
                        class="foll_tt_t ru5 sz12 mb10"
                        v-for="(ittr, index20) in item.affiliateNetworkLogos"
                        :key="index20"
                        v-show="index20 < 3"
                      >
                        <img :src="ittr" alt />
                      </div>
                      <el-popover placement="right" width="400" trigger="hover">
                        <div class="foll_title_rigg flex sz12 ru5">
                          <div
                            style="
                              display: flex;
                              width: 100% !important;
                              height: 100% !important;
                              flex-wrap: wrap !important;
                              overflow: auto !important;
                            "
                            class="foll_title_div flex"
                          >
                            <div
                              class="foll_tt_t ru5 sz12 mb10"
                              v-for="(
                                ittr, index21
                              ) in item.affiliateNetworkLogos"
                              :key="index21"
                            >
                              <img :src="ittr" alt />
                            </div>
                          </div>
                        </div>
                        <p
                          slot="reference"
                          class="foll_tt cursor center ru5 sz12"
                          v-if="item.affiliateNetworkLogos.length > 3"
                        >
                          ....
                        </p>
                      </el-popover>
                    </div>
                  </div>
                  <p
                    v-if="item.topFansNum && item.topFansNum != '0'"
                    class="sz12 titnames mb8 mt8"
                  >
                    粉丝数
                  </p>
                  <p v-else class="sz12 titnames mb8 mt8" style="opacity: 0">
                    .
                  </p>
                  <div
                    v-if="item.topFansNum && item.topFansNum != '0'"
                    class="flex mb8 logos_box"
                  >
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="item.fansType"
                      placement="bottom"
                    >
                      <img src="@/assets/img/logoIcon/youtube.png" />
                    </el-tooltip>

                    {{ item.topFansNum }}
                  </div>
                  <div v-else class="flex mb8 logos_box" style="opacity: 0">
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="item.fansType"
                      placement="bottom"
                    >
                      <img src="@/assets/img/logoIcon/youtube.png" />
                    </el-tooltip>

                    {{ item.topFansNum }}
                  </div>
                </div>
                <div class="detali_rght box">
                  <div class="sz12 mt8 mb8">带货商品</div>
                  <div class="detali_rght_img flex" v-show="item.goods">
                    <div class="detali_rght_one">
                      <img
                        :src="item.goods[0] ? item.goods[0] : ''"
                        :alt="item.goods[0] ? 'goodsImg' : ''"
                        :class="item.allianceCode"
                      />
                    </div>
                    <div class="detali_rght_one">
                      <img
                        :src="item.goods[1] ? item.goods[1] : ''"
                        :alt="item.goods[1] ? 'goodsImg' : ''"
                        :class="item.allianceCode"
                      />
                    </div>
                    <div class="detali_rght_one">
                      <img
                        :src="item.goods[2] ? item.goods[2] : ''"
                        :alt="item.goods[2] ? 'goodsImg' : ''"
                        :class="item.allianceCode"
                      />
                    </div>
                  </div>
                  <div class="detali_rght_img flex" v-show="!item.goods">
                    <div class="detali_rght_one">
                      <img src alt />
                    </div>

                    <div class="detali_rght_one">
                      <img src alt />
                    </div>
                    <div class="detali_rght_one">
                      <img src alt />
                    </div>
                  </div>
                </div>
                <div class="emalis flex alcen">
                  <div>
                    <div class="flex mb15">
                      <div class="emalisimg mr30 emalimag">
                        <el-tooltip
                          v-if="item.isConcern == 1"
                          class="item"
                          effect="dark"
                          content="取消关注"
                          placement="left"
                        >
                          <img
                            class="cursor"
                            src="@/assets/img/foll/love.png"
                            alt
                            @click="cancelgroup(item, 1)"
                          />
                        </el-tooltip>
                        <el-tooltip
                          v-else
                          class="item"
                          effect="dark"
                          content="关注"
                          placement="left"
                        >
                          <img
                            class="cursor"
                            src="@/assets/img/foll/love2new.png"
                            alt
                            @click="joingroup(item, 1)"
                          />
                        </el-tooltip>
                      </div>
                      <div class="emalisimg mg emalimag">
                        <el-tooltip
                          v-if="item.isCooperate == 1"
                          class="item cursor"
                          effect="dark"
                          content="移除合作分组"
                          placement="right"
                        >
                          <img
                            src="@/assets/img/foll/ws2new.png"
                            class
                            alt
                            @click="delCooperate(item, 1)"
                          />
                        </el-tooltip>
                        <el-tooltip
                          v-else
                          class="item cursor"
                          effect="dark"
                          content="加入合作分组"
                          placement="right"
                        >
                          <img
                            src="@/assets/img/foll/wsnew.png"
                            class
                            alt
                            @click="addCooperate(item, 1)"
                          />
                        </el-tooltip>
                      </div>
                    </div>
                    <div class="flex pad15">
                      <div
                        class="emalisimg mr30 emalimag"
                        v-if="item.hasEmail == 1"
                      >
                        <el-tooltip
                          class="item"
                          effect="dark"
                          content="发送邮件"
                          placement="left"
                        >
                          <img
                            class="cursor"
                            src="@/assets/img/foll/emlnew.png"
                            alt
                            @click="childMethod(item)"
                          />
                        </el-tooltip>
                      </div>
                      <div class="emalisimg mr30 emalimag" v-else>
                        <el-tooltip
                          class="item"
                          effect="dark"
                          content="暂无邮箱，更新中"
                          placement="left"
                        >
                          <img
                            class="cursor"
                            src="@/assets/img/foll/eml1new.png"
                            alt
                          />
                        </el-tooltip>
                      </div>
                      <div class="emalisimg mg emalimag2">
                        <el-tooltip
                          class="item"
                          effect="dark"
                          content="加入分组"
                          placement="right"
                        >
                          <img
                            class="cursor"
                            src="@/assets/img/foll/gdnew.png"
                            alt
                            @click="addgrouping(item, 1)"
                          />
                        </el-tooltip>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="detali mgbur">
              <div class="detali_zw center">更多数据更新中</div>
            </div>
            <div class="pages" v-if="brandsList.length">
              <Pagination
                v-if="restDay > 0"
                :pageNo="currentPage"
                :pageSize="size"
                :total="total"
                :continues="4"
                @getPageNo="currentchange"
              />
              <Pagination2 v-else :pageNo="1" :continues="4" />
            </div>
            <div
              class="w100 sz12 center"
              v-if="this.mealType == 'FREE_DAY' && this.currentPage == 2"
            >
              免费试用版本仅开放部分数据；如需完整的套餐，请您前往个人中心购买。
            </div>
          </div>
          <div class="mail" v-if="mailStuts">
            <div class="mail_center">
              <div class="mail_center_icon">
                <i class="el-icon-close cursor" @click="mailStuts = false"></i>
              </div>
              <div class="mail_center_icon_input">
                <el-input placeholder v-model="input4" maxlength="30">
                  <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
              </div>
              <div class="mail_mail">
                <div class="mail_mail_1 font_a">Cindy@fo***ds.com</div>
                <div class="mail_mail_2">
                  <img
                    class="cursor"
                    src="@/assets/img/home/emil.png"
                    alt
                    @click="dialogVisibleTwo = true"
                  />
                </div>
              </div>
              <div class="mail_mail">
                <div class="mail_mail_1 font_a">Cindy@fo***ds.com</div>
                <div class="mail_mail_2">
                  <img
                    class="cursor"
                    src="@/assets/img/home/emil.png"
                    alt
                    @click="dialogVisibleTwo = true"
                  />
                </div>
              </div>
              <div class="mail_mail">
                <div class="mail_mail_1 font_a">Cindy@fo***ds.com</div>
                <div class="mail_mail_2">
                  <img
                    class="cursor"
                    src="@/assets/img/home/emil.png"
                    alt
                    @click="dialogVisibleTwo = true"
                  />
                </div>
              </div>
            </div>
            <!-- <div class="mail_kf" > -->
            <div class="nologins_title" v-if="dialogVisibleTwo">
              <div class="nologins_title_icon">
                <i
                  class="el-icon-close cursor"
                  @click="dialogVisibleTwo = false"
                ></i>
              </div>
              <div class="nologins_title_img">
                <img src="@/assets/img/home/kf2.png" alt />
              </div>
              <div style="font-size: 16px" class="nologins_title_text center">
                目前为测试阶段,请联系客服
              </div>
            </div>
            <!-- </div> -->
          </div>
          <div v-show="tabStuts == 2">
            <div class="tit_bt">
              <span class="font_bo sz18">指定品牌</span>
            </div>
            <div class="tit_bt_identification flex">
              <p
                class="question ru50 center cursor"
                @mouseenter="mouseover"
                @mouseleave="mouseout"
              >
                ?
              </p>
              <p class="sz12 text" v-if="dialogVisible">
                佣金比例，EPC，Cookies均为预估值
              </p>
            </div>
            <div
              class="mark flex"
              id="ul"
              v-infinite-scroll="brandsLIstmapScroll"
              infinite-scroll-distance="50"
              infinite-scroll-delay="200"
              infinite-scroll-disabled="infiniteScrollFlag"
            >
              <div
                class="mark_list flex cursor"
                ref="brandsstin"
                v-for="(item, index1) in appointList"
                :key="index1"
                @click="topStutstwo(item, index1)"
                :class="bqstutsTwo == index1 ? 'markba' : 'marba2'"
                :id="index1 + 1"
              >
                <div class="mark_list_img">
                  <div class="ttiimg">
                    <img :src="item.brandLogo" alt />
                  </div>
                </div>
                <div class="text">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="item.brandName"
                    placement="top"
                  >
                    <div class="text_cenbter font_a sz12">
                      {{ item.brandName }}
                    </div>
                  </el-tooltip>
                </div>
                <div class="mark_icon">
                  <i
                    v-if="bqstutsTwo == index1"
                    class="el-icon-caret-bottom"
                  ></i>
                  <i v-else class="el-icon-caret-right"></i>
                </div>
              </div>
              <div class="empty"></div>
              <div class="empty"></div>
              <div class="empty"></div>
              <div class="empty"></div>
              <div class="empty"></div>
            </div>
            <div class="tab_left_select_gj mb5` flex" v-if="industryListmapTwo">
              <p class="sz12">国家/地区：</p>
              <el-select
                style="width: 200px; height: 30px"
                ref="upSelect"
                v-model="countrycode"
                placeholder="国家/地区"
                @change="selectgj"
              >
                <el-option
                  class="font_a"
                  v-for="item in dropdownList"
                  :key="item.countryCode"
                  :label="item.country"
                  :value="item.countryCode"
                ></el-option>
              </el-select>
              <!-- <i class="el-icon-caret-botto"></i> -->
            </div>
            <div class="tab" v-if="industryListmapTwo">
              <div class="tab_left">
                <div class="flex mb60 tettext">
                  <div class="flex tettext_list">
                    <p class="mr">
                      佣金比例&nbsp;&nbsp;
                      <span
                        class="co6e sz28"
                        :class="
                          industryListmapTwo.commissionRate === 'N/A'
                            ? 'font_a'
                            : ''
                        "
                      >
                        {{
                          industryListmapTwo.commissionRate
                            ? industryListmapTwo.commissionRate
                            : ''
                        }}
                      </span>
                    </p>
                  </div>
                  <div class="flex tettext_list">
                    <p>
                      &nbsp;&nbsp;EPC&nbsp;&nbsp;
                      <span
                        class="co6e sz28"
                        :class="
                          industryListmapTwo.epc === 'N/A' ? 'font_a' : ''
                        "
                        >{{ industryListmapTwo.epc }}</span
                      >
                    </p>
                  </div>
                  <div class="flex tettext_list">
                    <p>
                      Cookies&nbsp;&nbsp;
                      <span
                        class="co6e sz28"
                        :class="
                          industryListmapTwo.cookiesDay === 'N/A'
                            ? 'font_a'
                            : ''
                        "
                      >
                        {{ industryListmapTwo.cookiesDay }}天
                      </span>
                    </p>
                  </div>
                </div>
                <div class="flex titles">
                  <div class="mr ttsit">联盟平台</div>
                  <div
                    class="tab_left_img_list flex"
                    v-if="logoListLTwo.length"
                  >
                    <div
                      class="tab_left_img_t"
                      v-for="(item, index3) in logoListLTwo"
                      :key="index3"
                    >
                      <img :src="item" alt />
                    </div>
                  </div>
                </div>
              </div>
              <div class="tab_right">
                <div class="tab_right_img">
                  <p class="tab_right_img_p">联盟客类型</p>
                  <div class="tab_right_img_cha">
                    <div class="charts">
                      <div
                        id="myChart6"
                        :style="{ width: '100%', height: '100%' }"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 指定品牌 -->
            <div class="center_tit flex">
              <div class="font_bo text">联盟客详情</div>
              <div class="cent_input">
                <el-input
                  placeholder="请输入联盟客或网站名称"
                  @keyup.enter.native="nameclick(2)"
                  clearable
                  v-model="bname"
                ></el-input>
                <div class="icons">
                  <img src="../../assets/img/foll/search.png" alt />
                </div>
              </div>
              <div
                class="searchname ru5 center ba6e coff cursor sz16"
                @click="nameclick(2)"
              >
                搜索
              </div>
            </div>
            <div class="center_tit_con">
              <div class="center_tit_gj bord">
                <div class="center_tit_let">
                  <div class="co6e">国家/地区</div>
                  <div class="cursor allgj" @click="allTwo(0)">
                    <p :class="barndListStuts == -1 ? 'tit_lrestus' : ''">
                      全部
                    </p>
                  </div>
                </div>
                <div
                  class="center_tit_lre"
                  :class="brandfeed == true ? 'center_stuts' : ''"
                >
                  <div
                    class="center"
                    v-for="(item, index4) in countryList"
                    :key="index4"
                    @click="brandrestus(item, index4)"
                  >
                    <p :class="barndListStuts == index4 ? 'tit_lrestus' : ''">
                      {{ item.value }}
                    </p>
                  </div>
                </div>
                <div
                  class="center_tit_rig cursor"
                  v-if="countryList.length > 7"
                >
                  <div v-if="!brandfeed" @click="brandtype(1)">
                    <p>
                      展开
                      <i class="el-icon-caret-bottom"></i>
                    </p>
                  </div>
                  <div v-else @click="brandtype(2)">
                    <p>
                      收起
                      <i class="el-icon-caret-top"></i>
                    </p>
                  </div>
                </div>
                <div class="center_tit_rig" v-else></div>
              </div>
              <div class="center_tit_gj bord">
                <div class="center_tit_let">
                  <div class="co6e">类型</div>
                  <div class="cursor allgj" @click="allTwo(1)">
                    <p :class="barndListStutstwo == -1 ? 'tit_lrestus' : ''">
                      全部
                    </p>
                  </div>
                </div>
                <div
                  class="center_tit_lre"
                  :class="brandfeedTwo == true ? 'center_stuts' : ''"
                >
                  <div
                    class="center"
                    v-for="(item, index7) in typeList"
                    :key="index7"
                    @click="brandrestusTwo(item, index7)"
                  >
                    <p
                      :class="barndListStutstwo == index7 ? 'tit_lrestus' : ''"
                    >
                      {{ item.value }}
                    </p>
                  </div>
                </div>
                <div class="center_tit_rig cursor" v-if="screenList.length > 7">
                  <div v-if="!brandfeedTwo" @click="brandtypetwo(1)">
                    <p>
                      展开
                      <i class="el-icon-caret-bottom"></i>
                    </p>
                  </div>
                  <div v-else @click="brandtypetwo(2)">
                    <p>
                      收起
                      <i class="el-icon-caret-top"></i>
                    </p>
                  </div>
                </div>
                <div class="center_tit_rig" v-else></div>
              </div>
              <div class="center_tit_gj">
                <div class="center_tit_let">
                  <div class="co6e">平台</div>
                  <div class="cursor allgj" @click="allTwo(2)">
                    <p :class="barndListStutsshr == -1 ? 'tit_lrestus' : ''">
                      全部
                    </p>
                  </div>
                </div>
                <div
                  class="center_tit_lre"
                  :class="brandfeedsher == true ? 'center_stuts' : ''"
                >
                  <div
                    class="center"
                    v-for="(item, index8) in screenList"
                    :key="index8"
                    @click="brandrestusShr(item, index8, 2)"
                  >
                    <p
                      :class="barndListStutsshr == index8 ? 'tit_lrestus' : ''"
                    >
                      {{ item.value }}
                    </p>
                  </div>
                </div>
                <div class="center_tit_rig cursor" v-if="screenList.length > 7">
                  <div v-if="!brandfeedsher" @click="brandtypesher(1)">
                    <p>
                      展开
                      <i class="el-icon-caret-bottom"></i>
                    </p>
                  </div>
                  <div v-else @click="brandtypesher(2)">
                    <p>
                      收起
                      <i class="el-icon-caret-top"></i>
                    </p>
                  </div>
                </div>
                <div class="center_tit_rig" v-else></div>
              </div>
            </div>
            <div class="topArea">
              <el-radio-group
                v-model="orderRule"
                style
                @change="changeSortBrand"
              >
                <el-radio-button label="default">推荐 ❀</el-radio-button>
                <el-radio-button label="fans">
                  粉丝数
                  <span
                    style="display: inline-block; transform: translateY(-2px)"
                    >↓</span
                  >
                </el-radio-button>
                <el-radio-button label="newJoin">
                  发现时间
                  <span
                    style="display: inline-block; transform: translateY(-2px)"
                    >↓</span
                  >
                </el-radio-button>
              </el-radio-group>
              <div class="email">
                <el-checkbox-group
                  v-model="havaEmail2"
                  size="medium"
                  @change="changeEmail2"
                >
                  <el-checkbox-button style="display: flex" label="邮箱" key="1"
                    >{{ havaEmail2 ? '邮箱' : '全部' }} ✉</el-checkbox-button
                  >
                </el-checkbox-group>
              </div>
            </div>
            <div
              v-if="brandsListTwo.length"
              element-loading-spinner="el-icon-loading"
            >
              <div
                class="detali flex detaliTwo alcen"
                v-for="(item, index5) in brandsListTwo"
                :key="item.allianceCode"
                :class="detaliStutstwo == index5 ? 'detaliTwo' : ''"
                @click="detaliqxtwo(index5)"
              >
                <div class="detali_let flex box alcen">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="本月新发现联盟客"
                    placement="right"
                  >
                    <img
                      v-if="item.isNewJoin === 1"
                      class="newtag"
                      src="@/assets/img/home/new.png"
                    />
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="已联系联盟客"
                    placement="right"
                  >
                    <img
                      v-if="item.isContact === 1"
                      class="newtag2"
                      src="@/assets/img/home/contact.png"
                    />
                  </el-tooltip>
                  <!-- <div class="hotbq sz30 co6e font_a" v-if="item.tagNew">NEW!</div>
                  <div class="hotbq sz30 co6e font_a" v-else-if="item.true">HOT!</div>
                  <div class="hotbq sz30 co6e font_a" v-else-if="item.tagActive">ACTIVE!</div>-->
                  <div class="detali_let_one flex">
                    <div class="detali_let_one_img cursor">
                      <img
                        v-if="item.headSrc"
                        :src="item.headSrc"
                        alt="headImg"
                        :class="item.allianceCode"
                        @click="godetil(item)"
                      />
                      <img
                        v-else
                        src="@/assets/img/default.png"
                        alt
                        @click="godetil(item)"
                      />
                    </div>
                  </div>
                  <div class="category">
                    <div class="flex mb6 alcen">
                      <p
                        class="let_one_p_name mr10 cursor font_bo"
                        @click="godetil(item)"
                      >
                        {{ item.name }}
                      </p>
                      <p class="let_one_p_gj sz12">{{ item.countryName }}</p>
                    </div>
                    <div class="flex mb6">
                      <p class="sz12 labelbox h25">行业</p>
                      <div v-if="item.types" class="foll_title">
                        <div class="foll_tt_top">
                          <p
                            class="foll_tt baffeef5 center ru5 sz12"
                            v-for="(ittr, index17) in item.types"
                            :key="index17"
                            v-show="index17 < 3"
                          >
                            {{ ittr }}
                          </p>
                          <el-tooltip
                            class="item"
                            effect="dark"
                            placement="right"
                            v-if="item.types.length > 3"
                          >
                            <div slot="content" class="foll_tt_d flex">
                              <p
                                class="mb8 mr10 coff"
                                v-for="(ittr, index16) in item.types"
                                :key="index16"
                              >
                                {{ ittr }}
                              </p>
                            </div>
                            <p
                              class="cursor"
                              style="width: 20px"
                              v-show="item.types.length > 3"
                            >
                              ...
                            </p>
                          </el-tooltip>
                        </div>
                      </div>
                    </div>
                    <div class="flex mb6">
                      <p class="sz12 labelbox h25">类型</p>
                      <div v-if="item.promoType" class="foll_title">
                        <div class="foll_tt_top">
                          <p
                            class="foll_tt baffeef5 center ru5 sz12"
                            v-for="(ittr, index26) in item.promoType"
                            :key="index26"
                            v-show="index26 < 3"
                          >
                            {{ ittr }}
                          </p>
                          <el-tooltip
                            class="item"
                            effect="dark"
                            placement="right"
                            v-if="item.promoType.length > 3"
                          >
                            <div slot="content" class="foll_tt_d flex">
                              <p
                                class="mb8 mr10 coff"
                                v-for="(ittr, index27) in item.promoType"
                                :key="index27"
                              >
                                {{ ittr }}
                              </p>
                            </div>
                            <p
                              class="cursor"
                              style="width: 20px"
                              v-show="item.promoType.length > 3"
                            >
                              ...
                            </p>
                          </el-tooltip>
                        </div>
                      </div>
                    </div>
                    <div class="flex mb6">
                      <p class="sz12 labelbox h25">品牌</p>
                      <div v-if="item.brands" class="foll_title">
                        <p
                          class="foll_tt ttres baffeef5 center ru5 sz12"
                          v-for="(ittr, index24) in item.brands"
                          :key="index24"
                          v-show="index24 < 3"
                        >
                          {{ ittr }}
                        </p>
                        <el-tooltip
                          class="item"
                          effect="dark"
                          placement="right"
                          v-if="item.brands.length > 3"
                        >
                          <div slot="content" class="foll_tt_d flex">
                            <p
                              class="mb8 mr10 coff"
                              v-for="(ittr, index25) in item.brands"
                              :key="index25"
                            >
                              {{ ittr }}
                            </p>
                          </div>
                          <p
                            class="cursor"
                            style="width: 20px"
                            v-show="item.brands.length > 3"
                          >
                            ...
                          </p>
                        </el-tooltip>
                      </div>
                    </div>
                    <div v-if="item.category" class="flex mb6">
                      <p class="sz12 labelbox h25">分类</p>
                      <div class="foll_title">
                        <div class="foll_tt_top">
                          <p
                            class="foll_tt baffeef5 center ru5 sz12 ttres"
                            v-for="(ittr, index17) in item.category"
                            :key="index17"
                            v-show="index17 < 3"
                          >
                            {{ ittr }}
                          </p>
                          <el-tooltip
                            class="item"
                            effect="dark"
                            placement="right"
                            v-if="item.category.length > 3"
                          >
                            <div slot="content" class="foll_tt_d flex">
                              <p
                                class="mb8 mr10 coff"
                                v-for="(ittr, index16) in item.category"
                                :key="index16"
                              >
                                {{ ittr }}
                              </p>
                            </div>
                            <p
                              class="cursor"
                              style="width: 20px"
                              v-show="item.category.length > 3"
                            >
                              ...
                            </p>
                          </el-tooltip>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="detali_cont boxz">
                  <div class="mb8">
                    <p class="sz12 titnames mb8 mt8">联盟平台</p>
                    <div
                      class="foll_title_top"
                      v-if="item.affiliateNetworkLogos"
                    >
                      <div
                        class="foll_tt_t ru5 sz12 mb10"
                        v-for="(ittr, index22) in item.affiliateNetworkLogos"
                        :key="index22"
                        v-show="index22 < 3"
                      >
                        <img :src="ittr" alt />
                      </div>
                      <el-popover placement="right" width="400" trigger="hover">
                        <div class="foll_title_rigg flex sz12 ru5">
                          <div
                            style="
                              display: flex;
                              width: 100% !important;
                              height: 100% !important;
                              flex-wrap: wrap !important;
                              overflow: auto !important;
                            "
                            class="foll_title_div flex"
                          >
                            <div
                              class="foll_tt_t ru5 sz12 mb10"
                              v-for="(
                                ittr, index23
                              ) in item.affiliateNetworkLogos"
                              :key="index23"
                            >
                              <img :src="ittr" alt />
                            </div>
                          </div>
                        </div>
                        <p
                          slot="reference"
                          class="foll_tt cursor center ru5 sz12"
                          v-if="item.affiliateNetworkLogos.length > 3"
                        >
                          ....
                        </p>
                      </el-popover>
                    </div>
                  </div>
                  <p
                    v-if="item.topFansNum && item.topFansNum != '0'"
                    class="sz12 titnames mb8 mt8"
                  >
                    粉丝数
                  </p>
                  <p v-else class="sz12 titnames mb8 mt8" style="opacity: 0">
                    .
                  </p>
                  <div
                    v-if="item.topFansNum && item.topFansNum != '0'"
                    class="flex mb8 logos_box"
                  >
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="item.fansType"
                      placement="bottom"
                    >
                      <img src="@/assets/img/logoIcon/youtube.png" />
                    </el-tooltip>

                    {{ item.topFansNum }}
                  </div>
                  <div v-else class="flex mb8 logos_box" style="opacity: 0">
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="item.fansType"
                      placement="bottom"
                    >
                      <img src="@/assets/img/logoIcon/youtube.png" />
                    </el-tooltip>

                    {{ item.topFansNum }}
                  </div>
                </div>

                <div class="detali_rght box">
                  <div class="sz12 mt8 mb8">带货商品</div>
                  <div class="detali_rght_img flex" v-show="item.goods">
                    <div class="detali_rght_one">
                      <img
                        :src="item.goods[0] ? item.goods[0] : ''"
                        :alt="item.goods[0] ? 'goodsImg' : ''"
                        :class="item.allianceCode"
                      />
                    </div>
                    <div class="detali_rght_one">
                      <img
                        :src="item.goods[1] ? item.goods[1] : ''"
                        :alt="item.goods[1] ? 'goodsImg' : ''"
                        :class="item.allianceCode"
                      />
                    </div>
                    <div class="detali_rght_one">
                      <img
                        :src="item.goods[2] ? item.goods[2] : ''"
                        :alt="item.goods[2] ? 'goodsImg' : ''"
                        :class="item.allianceCode"
                      />
                    </div>
                  </div>
                  <div class="detali_rght_img flex" v-show="!item.goods">
                    <div class="detali_rght_one">
                      <img src alt />
                    </div>
                    <div class="detali_rght_one">
                      <img src alt />
                    </div>
                    <div class="detali_rght_one">
                      <img src alt />
                    </div>
                  </div>
                </div>
                <div class="emalis flex alcen">
                  <div>
                    <div class="flex mb15">
                      <div class="emalisimg mr30 emalimag">
                        <el-tooltip
                          v-if="item.isConcern == 1"
                          class="item"
                          effect="dark"
                          content="取消关注"
                          placement="left"
                        >
                          <img
                            class="cursor"
                            src="@/assets/img/home/love.png"
                            alt
                            @click="cancelgroup(item, 2)"
                          />
                        </el-tooltip>
                        <el-tooltip
                          v-else
                          class="item"
                          effect="dark"
                          content="关注"
                          placement="left"
                        >
                          <img
                            class="cursor"
                            src="@/assets/img/home/love2.png"
                            alt
                            @click="joingroup(item, 2)"
                          />
                        </el-tooltip>
                      </div>
                      <div class="emalisimg mg emalimag">
                        <el-tooltip
                          v-if="item.isCooperate == 1"
                          class="item cursor"
                          effect="dark"
                          content="移除合作分组"
                          placement="right"
                        >
                          <img
                            src="@/assets/img/foll/ws2new.png"
                            class
                            alt
                            @click="delCooperate(item, 2)"
                          />
                        </el-tooltip>
                        <el-tooltip
                          v-else
                          class="item cursor"
                          effect="dark"
                          content="加入合作分组"
                          placement="right"
                        >
                          <img
                            src="@/assets/img/foll/wsnew.png"
                            class
                            alt
                            @click="addCooperate(item, 2)"
                          />
                        </el-tooltip>
                      </div>
                    </div>
                    <div class="flex pad15">
                      <div
                        class="emalisimg mr30 emalimag"
                        v-if="item.hasEmail == 1"
                      >
                        <el-tooltip
                          class="item"
                          effect="dark"
                          content="发送邮件"
                          placement="left"
                        >
                          <img
                            class="cursor"
                            src="@/assets/img/foll/emlnew.png"
                            alt
                            @click="childMethod(item)"
                          />
                        </el-tooltip>
                      </div>
                      <div class="emalisimg mr30 emalimag" v-else>
                        <el-tooltip
                          class="item"
                          effect="dark"
                          content="暂无邮箱，更新中"
                          placement="left"
                        >
                          <img
                            class="cursor"
                            src="@/assets/img/foll/eml1new.png"
                            alt
                          />
                        </el-tooltip>
                      </div>
                      <div class="emalisimg mg emalimag2">
                        <el-tooltip
                          class="item"
                          effect="dark"
                          content="加入分组"
                          placement="right"
                        >
                          <img
                            class="cursor"
                            src="@/assets/img/foll/gdnew.png"
                            alt
                            @click="addgrouping(item, 2)"
                          />
                        </el-tooltip>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="detali mgbur">
              <div class="detali_zw center">更多数据更新中</div>
            </div>
            <div
              style="margin-top: 25px"
              class="pages"
              v-if="brandsListTwo.length"
            >
              <Pagination
                :pageNo="currentPageTwo"
                :pageSize="sizeTwo"
                :total="totalTwo"
                :continues="4"
                @getPageNo="currentChangeTwo"
              />
            </div>
            <div
              class="w100 sz12 center"
              v-if="this.mealType == 'FREE_DAY' && this.currentPageTwo == 2"
            >
              免费试用版本仅开放部分数据；如需完整的套餐，请您前往个人中心购买。
            </div>
          </div>
          <div class="grouping" v-if="groupingstuts">
            <div class="top ru5">
              <div class="top_icon cursor" @click="gbtca">
                <i class="el-icon-close"></i>
              </div>
              <div class="top_top flex">
                <div
                  class="top_p cursor"
                  v-for="(ite, index) in follListTwo"
                  :key="index"
                  @click="addfools(ite, index)"
                >
                  <div class="top_img flex" :class="ite.isname ? 'borre' : ''">
                    <img src="@/assets/img/foll/wjj.png" alt />
                  </div>
                  <p class="sz14">{{ ite.groupName }}</p>
                </div>
              </div>
              <div class="butt">
                <div class="button_div cursor" @click="follsubmit">确定</div>
                <div class="text sz12" v-if="follListTwo.length < 3">
                  进入我的关注页面可创建更多分组
                </div>
                <div class="text sz12" v-if="follListTwo.length > 2">
                  可多选
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="top1_butt">
              <div class="top1_privacy font_r center">
                <!-- <a class="font_r cursor" @click="test3">Influencers Privacy Policy</a> -->
              </div>
            </div>
            <div class="top1_butt_b"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="nologins" v-if="dialogVisiblesfor">
      <div class="nologins_title">
        <div style="text-align: right" class="nologins_title_icon">
          <!-- <i class="el-icon-close cursor" @click="dialogVisibleTwos"></i> -->
        </div>
        <div class="nologins_title_text center">
          <p class="sz14">请前往个人中心配置您所需的行业及品牌</p>
          <div class="flex mt20 mb20 alcen">
            <p class="yes center cursor ba6e coff ru5 sz14" @click="renewinfo">
              返回个人中心
            </p>
            <!-- <p class="yes center cursor sz14 ru5 coff ba00" @click="renew(2)">升级套餐</p> -->
          </div>
        </div>
      </div>
    </div>

    <div class="expire" v-if="mealType == 'FREE_DAY'">
      <div class="w100 h100 ba6e" v-if="guicon">
        <div class="expire_top w100 h100 flex coff jucen alcen">
          <span>免费体验账号仅显示有限数据，敬请购买套餐查看更多数据</span>
          <p class="expire_icon cursor" @click="guicon = false">
            <i class="el-icon-close"></i>
          </p>
        </div>
      </div>
    </div>

    <!-- 右键菜单 -->
    <right-menu
      :class-index="0"
      :rightclickInfo="rightclickInfo"
      @complaint="hanldeRightClick"
    ></right-menu>

    <appeal-modal ref="appealModal"></appeal-modal>
  </div>
</template>
<script>
import {
  INDUSTRYS,
  BRANDSBYINDUSTRY,
  BRANDS,
  BRAND,
  CHECKBRAND,
  COUNTRYBRAND,
  INDUSTRYY,
  QUERYSELECTLIST,
  QUERYUSERGROUP,
  QUERY,
  JOINGROUP,
  CHECKALLINDUSTRYBRAND,
  QUERYHASGROUP,
  QUERYCHAT
} from '../../api/cutting'
import { CHECKBATCHSENDEMAIL } from '@/api/emial'
import { RECORDS } from '../../api/personal'
import { REMOVEGROUPONEDETAIL } from '../../api/foll'
import { mapActions, mapGetters } from 'vuex'
export default {
  components: {
    rightMenu: () => import('@/components/rightMenu.vue'),
    appealModal: () => import('@/components/appealModal.vue')
  },
  props: ['getStudentName'],
  data() {
    return {
      carstuts: 2,
      // screenheight: "480px",
      aname: '',
      bname: '',
      input4: '',
      dialogVisible: false,
      dialogVisibleTwo: false,
      tabStuts: 1, // Tab选中状态
      industryStuts: 0, //行业选中状态
      bqstuts: 0, // 标杆选中状态
      bqstutsTwo: 0, // 指定品牌选中状态
      mailStuts: false,
      industryList: [],
      logoListL: [],
      logoListLmap: {
        logoListL: [], //平台log
        logoListL2: [], //平台log
        logoListL3: [], //平台log
        logoListL4: [], //平台log
        logoListL5: [], //平台log
        logoListL6: [] //平台log
      },
      logoListLTwo: [], // 品牌log
      currentPage: 1,
      size: 10,
      sizeTwo: 10,
      currentPageTwo: 1,
      total: 0,
      totalTwo: 0,
      brandsList: [],
      brandsListTwo: [],
      brand: '',
      industry: '',
      dropdownList: [],
      platformobj: {},
      yDatamap: {
        yData: [],
        yData2: [],
        yData3: [],
        yData4: [],
        yData5: [],
        yData6: []
      },
      yDatatWO: [],
      select: '',
      appointList: [], // 指定品牌列表
      industryListmap: {}, // 标杆信息
      industryListmapTwo: {
        commissionRate: '',
        epc: '',
        cookiesDay: ''
      }, //行业标杆信息
      brandname: '',
      bRandname: '',
      countrycode: '', //  默认获取国家
      countryList: [], // 模糊查询国家内容
      typeList: [], // 模糊查询类型
      screenList: [], // 糊查询平台
      countryListTwo: [], // 模糊查询国家内容
      typeListTwo: [], // 模糊查询类型
      screenListTwo: [], // 糊查询平台
      feed: false, // 点击展示更多国家
      feedTwo: false, // 点击展示更多类型
      feedsher: false, // 点击展示更多平台
      brandfeed: false, // 点击展示更多国家
      brandfeedTwo: false, // 点击展示更多类型
      brandfeedsher: false, // 点击展示更多平台
      countryListStuts: -1, // 行业国家选择   行业
      countryListStutstwo: -1, // 行业类型选择  行业
      countryListStutsshr: -1, // 行业平台选择  行业
      barndListStuts: -1, // 行业国家选择   平台
      barndListStutstwo: -1, // 行业类型选择  平台
      barndListStutsshr: -1, // 行业平台选择  平台
      country: '', // 国家

      propTypes: '', // 类型
      affiliateNetworks: '', // 平台
      countryTwo: '', // 国家
      propTypesTwo: '', // 类型
      affiliateNetworksTwo: '', // 平台
      groupingstuts: false, // 分组
      follList: [], // 分组列表
      follListTwo: [], // 分组列表
      detaillist: [], //选中的分株
      brandLogo: '',
      brandLogomap: {
        brandLogo: '',
        brandLogo2: '',
        brandLogo3: '',
        brandLogo4: '',
        brandLogo5: '',
        brandLogo5: ''
      },
      brandNamemap: {
        brandName: '',
        brandName2: '',
        brandName3: '',
        brandName4: '',
        brandName5: '',
        brandName6: '',
        countryname: '', // 国家
        countryname2: '', // 国家
        countryname3: '', // 国家
        countryname4: '', // 国家
        countryname5: '', // 国家
        countryname6: '' // 国家
      },
      allianceCode: '', // 联盟客code
      detaliStuts: 0,
      detaliStutstwo: 0,
      type: '',
      searchStuts: false,
      value: '',
      usnameList: [],
      dialogVisiblesfor: false,
      screenWidth: '',
      countryBrandmap: {
        countryBrand: {
          domain: '',
          commissionRate: '',
          epc: '',
          cookiesDay: ''
        },
        countryBrand2: {
          domain: '',
          commissionRate: '',
          epc: '',
          cookiesDay: ''
        },
        countryBrand3: {
          domain: '',
          commissionRate: '',
          epc: '',
          cookiesDay: ''
        },
        countryBrand4: {
          domain: '',
          commissionRate: '',
          epc: '',
          cookiesDay: ''
        },
        countryBrand5: {
          domain: '',
          commissionRate: '',
          epc: '',
          cookiesDay: ''
        },
        countryBrand6: {
          domain: '',
          commissionRate: '',
          epc: '',
          cookiesDay: ''
        }
      },
      comstuts: null,
      validParam: localStorage.getItem('validParam'),
      arr1: [],
      endDatestuts: false,
      mealType: '',
      restDay: '',
      endDate: '',

      // 品牌滚动参数
      brandsParams: {
        currentPage: 1,
        size: 100
      },
      infiniteScrollFlag: false,
      tableLoading: false, //列表加载状态
      isend: false, //是否加载完
      textCount: 0,
      timer: null,
      searchTimer: null,
      guicon: true,

      biaoBrandList1: [],
      biaoBrandList2: [],
      orderRule: 'default',
      havaEmail1: false,
      havaEmail2: false,

      rightclickInfo: {}
    }
  },
  created() {
    if (this.validParam !== 'ig') {
      this.$bus.$emit('showNopermiss', true)
    }
    this.industrys() // 获取行业
    // this.initIndustry();
    this.permitsList() // 获取赛选条件
    this.queryUserGroup() // 查询分组
    this.decords()
  },
  mounted() {
    document.addEventListener('contextmenu', (event) => {
      console.log(event)
      if (
        event.button == 2 &&
        (event.target.alt == 'headImg' || event.target.alt == 'goodsImg')
      ) {
        let pictureUrl = event.srcElement.currentSrc
        let pictureType = event.target.alt
        let allianceCode = event.target.className
        this.rightclickInfo = {
          position: {
            x: event.clientX,
            y: event.clientY
          },
          menulists: [
            {
              fnName: 'complaint',
              params: {
                pictureUrl: pictureUrl,
                pictureType: pictureType,
                allianceCode: allianceCode
              },
              icoName: 'el-icon-document-copy',
              btnName: '申诉下架'
            }
          ]
        }
        event.preventDefault() // 阻止默认的鼠标右击事件
      }
    })

    window.onresize = () => {
      this.$nextTick(() => {
        // this.screenWidth = document.body.clientWidth;
        // if (this.screenWidth > 1600) {
        //   this.screenheight = "670px";
        // } else {
        //   this.screenheight = "495px";
        // }
        this.drawPie1()
        this.drawPie2()
      })
    }
  },
  methods: {
    ...mapActions(['changeUserIndustrys']),
    // 获取购买记录
    decords() {
      RECORDS({
        userId: this.id
      }).then((res) => {
        if (res.data.body.endDate) {
          let date1_s = res.data.body.endDate.replace(/\-/g, '/')
          let date2_s = this.$moment()
            .format('YYYY-MM-DD HH:mm:ss')
            .replace(/\-/g, '/')
          let date1_unix = Date.parse(date1_s) //將字符串格式日期转化为时间戳，就是1970年到当前日期的毫秒数
          let date2_unix = Date.parse(date2_s) //將字符串格式日期转化为时间戳，就是1970年到当前日期的毫秒数
          if (date1_unix - date2_unix > 0) {
            this.endDatestuts = true // 未过期
          } else if (date1_unix - date2_unix < 0) {
            this.endDatestuts = false // 已经过期
          }
          this.endDate = res.data.body.endDate
        }
        this.mealType = res.data.body.mealType
        this.restDay = res.data.body.restDay
      })
    },
    /**
     * 套餐续费/ s升级
     */
    renew(e) {
      this.$router.push('./package')
    },
    renewinfo() {
      this.$router.push({ path: './demo', query: { r: 6 } })
    },
    spage(e) {},
    mouseover() {
      this.dialogVisible = true
    },
    mouseout() {
      this.dialogVisible = false
    },
    arrowClick(val) {
      this.carstuts = 2
      this.$refs.cardShow.setActiveItem(0)
    },
    arrowClicktwo(val) {
      this.carstuts = 1
      this.$refs.cardShow.setActiveItem(1)
    },
    dialogVisibleTwos() {
      this.dialogVisiblesher = false
      // this.navigationStuts = 1
    },
    unames() {
      clearTimeout(this.searchTimer)
      if (this.value) {
        this.searchTimer = setTimeout(() => {
          this.searchStuts = true
          CHECKALLINDUSTRYBRAND({ value: this.value }).then((res) => {
            this.usnameList = res.data.body
          })
        }, 300)
      } else {
        this.searchStuts = false
      }
    },
    cnames() {
      setTimeout(() => {
        this.searchStuts = false
      }, 500)
    },
    bnames() {
      if (this.value) {
        this.searchStuts = true
      }
    },
    searchscli(e) {
      this.currentPage = 1
      this.currentPageTwo = 1
      var str = e.code
      if (e.type === 'industry') {
        this.carstuts = 2
        this.$refs.cardShow.setActiveItem(0)
        let result_one = this.industryList.some(function (item) {
          if (item.bigIndustryCode == str) {
            return true //返回false
          }
        })
        if (result_one) {
          this.tabStuts = 1
          this.industry = e.code
          this.industryStuts = this.industryList.findIndex(
            (item) => item.bigIndustryCode === e.code
          )
          BRANDSBYINDUSTRY({ bigIndustryCode: e.code }).then((res) => {
            if (res.data.body) {
              let temp = res.data.body
              this.biaoBrandList1 = []
              this.biaoBrandList2 = []
              temp.forEach((item, index) => {
                if (index < 3) {
                  this.biaoBrandList1.push(item)
                }
                if (index > 2 && index < 6) {
                  this.biaoBrandList2.push(item)
                }
              })
              if (res.data.body[0]) {
                this.yDatamap.yData = res.data.body[0].types
              }
              if (res.data.body[1]) {
                this.yDatamap.yData2 = res.data.body[1].types
              }
              if (res.data.body[2]) {
                this.yDatamap.yData3 = res.data.body[2].types
              }
              if (res.data.body[3]) {
                this.yDatamap.yData4 = res.data.body[3].types
              }
              if (res.data.body[4]) {
                this.yDatamap.yData5 = res.data.body[4].types
              }
              if (res.data.body[5]) {
                this.yDatamap.yData6 = res.data.body[5].types
              }
              this.$nextTick(() => {
                this.drawPie1()
              })
            } else {
              this.biaoBrandList1 = []
              this.biaoBrandList2 = []
            }
          })
          this.detaals()
        } else {
          this.$bus.$emit('showNopermiss', true)
        }
      } else if (e.type === 'brand') {
        CHECKBRAND({
          permitType: 'brand',
          permitCode: str
        }).then((res) => {
          if (res.data.body == 1) {
            this.tabStuts = 2
            this.brand = e.code
            this.bqstutsTwo = this.appointList.findIndex(
              (item) => item.brandCode === e.code
            )
            COUNTRYBRAND({ brandCode: e.code }).then((res) => {
              if (res.data.body.length > 0) {
                this.countrycode = res.data.body[0]
                  ? res.data.body[0].countryCode
                  : null
                this.logoListLTwo =
                  res.data.body[0].allianceGuestPlatformLogos.split(',')
                this.industryListmapTwo = res.data.body[0]
                  ? res.data.body[0]
                  : null
                this.dropdownList = res.data.body
                this.brandLogo = res.data.body[0].logoSrc
                this.bRandname = e.name
                this.yDatatWO = res.data.body[0].types
                this.$nextTick(() => {
                  this.drawPie2()
                })
              } else {
                this.logoListLTwo = ''
                this.industryListmapTwo = null
                this.dropdownList = []
                this.yDatatWO = []
                this.$nextTick(() => {
                  this.drawPie2()
                })
              }
              this.$nextTick(() => {
                this.appointList
              })
              var str = this.$refs.brandsstin
              var hrightid = str.some((item) => {
                if (item.innerText == e.name) {
                  let target = document.getElementById(item.id)
                  let parent = document.getElementById('ul')
                  parent.scrollTop = target.offsetTop - parent.offsetTop
                }
              })
            })
            this.BRANDList()
          } else {
            this.$bus.$emit('showNopermiss', true)
          }
        })
      }
    },
    // 联盟了名字赛选
    nameclick(e) {
      if (e == 1) {
        this.currentPage = 1
        this.detaals()
      } else {
        this.currentPageTwo = 1
        this.BRANDList()
      }
    },
    /***
     * tabclick()
     * tab切换
     */

    tabclick(e) {
      this.carstuts = 2
      this.currentPage = 1
      this.currentPageTwo = 1
      this.orderRule = 'default'
      this.$refs.cardShow.setActiveItem(0)
      if (e == 1) {
        this.tabStuts = 1
        this.$nextTick(() => {
          this.bqstuts = 0
          this.industryStuts = 0
          this.industrys()
        })
      } else {
        this.tabStuts = 2
        this.$nextTick(() => {
          this.bqstutsTwo = 0
          this.brandsLIstmap()
        })
      }
    },
    /**
     * queryUserGroup()查询分组
     */
    queryUserGroup() {
      QUERYUSERGROUP().then((res) => {
        this.follList = []
        let arr = res.data.body
        arr.map((item) => {
          this.follList.push(Object.assign({}, item, { isname: false }))
        })
      })
    },
    // 选择分组
    addfools(e, index, v) {
      this.follListTwo[index].isname = !this.follListTwo[index].isname
      for (var i = 0; i < this.follListTwo.length; i++) {
        if (this.follListTwo[i].isname == false) {
          // this.chooseAll = false;
          break
        }
      }
      if (i == this.follListTwo.length) {
      }
      if (e.isname == true) {
        this.detaillist.push({
          groupCode: e.groupCode,
          allianceCode: this.allianceCode
        })
      } else {
        this.detaillist.splice(i, 1)
      }
    },
    // 确认添加
    follsubmit() {
      if (!this.detaillist.length) {
        this.$message.warning('请选择分组')
        return
      }
      JOINGROUP({
        userGroups: this.detaillist
      }).then((res) => {
        if (res.data.code == 'success') {
          this.$message({
            message: '添加成功',
            type: 'success'
          })
          this.groupingstuts = false
          this.detaillist = []
          this.follListTwo = []
          for (var i = 0; i < this.follListTwo.length; i++) {
            this.follListTwo[i].isname = false
          }
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 关闭分组
    gbtca() {
      this.groupingstuts = false
      this.detaillist = []
      this.follListTwo = []
      for (var i = 0; i < this.follListTwo.length; i++) {
        var item = this.follListTwo[i]
        if (item.isname) {
          item.isname = false
        }
      }
    },
    /**
     * industryClck()
     * 选择行业
     */
    industryClck(e, index) {
      if (e.isEffective === 0) {
        this.$bus.$emit('showNopermiss', true)
        return false
      }
      this.industryStuts = index
      this.carstuts = 2
      this.$refs.cardShow.setActiveItem(0)
      this.currentPage = 1
      this.$nextTick(() => {
        this.bqstuts = 0
      })
      this.industry = e.bigIndustryCode
      BRANDSBYINDUSTRY({ bigIndustryCode: e.bigIndustryCode }).then((res) => {
        if (res.data.body.length > 0) {
          let temp = res.data.body
          this.biaoBrandList1 = []
          this.biaoBrandList2 = []
          temp.forEach((item, index) => {
            if (index < 3) {
              this.biaoBrandList1.push(item)
            }
            if (index > 2 && index < 6) {
              this.biaoBrandList2.push(item)
            }
          })
          if (res.data.body[0]) {
            this.yDatamap.yData = res.data.body[0].types
          }
          if (res.data.body[1]) {
            this.yDatamap.yData2 = res.data.body[1].types
          }
          if (res.data.body[2]) {
            this.yDatamap.yData3 = res.data.body[2].types
          }
          if (res.data.body[3]) {
            this.yDatamap.yData4 = res.data.body[3].types
          }
          if (res.data.body[4]) {
            this.yDatamap.yData5 = res.data.body[4].types
          }
          if (res.data.body[5]) {
            this.yDatamap.yData6 = res.data.body[5].types
          }
          this.$nextTick(() => {
            this.drawPie1()
          })
        } else {
          this.biaoBrandList1 = []
          this.biaoBrandList2 = []
        }
      })
      this.detaals()
    },
    // 选择指定品牌
    topStutstwo(e, index) {
      this.currentPageTwo = 1
      this.bqstutsTwo = index
      this.brand = e.brandCode
      COUNTRYBRAND({ brandCode: e.brandCode }).then((res) => {
        this.bRandname = e.brandName
        this.brandLogo = e.brandLogo
        if (res.data.body) {
          if (res.data.body[0]) {
            this.countrycode = res.data.body[0].countryCode
            this.dropdownList = res.data.body
            this.logoListLTwo =
              res.data.body[0].allianceGuestPlatformLogos.split(',')
            this.industryListmapTwo = res.data.body[0]
            this.yDatatWO = res.data.body[0].types
            this.$nextTick(() => {
              this.drawPie2()
            })
            if (!res.data.body[0].types) {
              this.yDatatWO = []
              this.$nextTick(() => {
                this.drawPie2()
              })
            }
          } else {
            this.industryListmapTwo = null
          }
        } else {
          this.dropdownList = []
          this.logoListLTwo = []
          this.industryListmapTwo = null
          this.yDatatWO = []
          this.$nextTick(() => {
            this.drawPie2()
          })
        }
      })
      this.BRANDList()
    },
    // 指定品牌选择国家后更改数据
    selectgj(e) {
      var obj =
        this.dropdownList[
          this.dropdownList.findIndex((role) => role.countryCode === e)
        ]
      this.industryListmap = obj
      this.industryListmapTwo = obj
      this.industryListmapTwo.commissionRate = obj.commissionRate
      this.industryListmapTwo.epc = obj.epc
      this.industryListmapTwo.cookiesDay = obj.cookiesDay
      this.logoListLTwo = obj.allianceGuestPlatformLogos.split(',') // 数据处理 字符串转数组
      this.yDatatWO = obj.types
      this.$nextTick(() => {
        this.drawPie2()
      })
    },
    clickOutSide() {
      this.$refs.upSelect.blur()
    },
    initIndustry() {
      let industryObj = JSON.parse(localStorage.getItem('userIndustry'))
      this.industryList = industryObj.industryList
      this.biaoBrandList1 = industryObj.biaoBrandList1
      this.biaoBrandList2 = industryObj.biaoBrandList2
      this.yDatamap = industryObj.yDatamap
      this.industry = this.industryList[0].bigIndustryCode
      this.$nextTick(() => {
        this.drawPie1()
      })
      this.detaals()
    },
    // 获取行业
    industrys() {
      INDUSTRYS().then((res) => {
        if (res.data.body.length) {
          this.industryList = res.data.body
          this.industry = res.data.body[0].bigIndustryCode
          BRANDSBYINDUSTRY({
            bigIndustryCode: res.data.body[0].bigIndustryCode
          }).then((res) => {
            if (res.data.body) {
              let temp = res.data.body
              this.biaoBrandList1 = []
              this.biaoBrandList2 = []
              temp.forEach((item, index) => {
                if (index < 3) {
                  this.biaoBrandList1.push(item)
                }
                if (index > 2 && index < 6) {
                  this.biaoBrandList2.push(item)
                }
              })
              if (temp.length === 1) {
                this.biaoBrandList1.push({})
                this.biaoBrandList1.push({})
                this.biaoBrandList2.push({})
                this.biaoBrandList2.push({})
                this.biaoBrandList2.push({})
              }
              if (temp.length === 2) {
                this.biaoBrandList1.push({})
                this.biaoBrandList2.push({})
                this.biaoBrandList2.push({})
                this.biaoBrandList2.push({})
              }
              if (temp.length === 3) {
                this.biaoBrandList2.push({})
                this.biaoBrandList2.push({})
                this.biaoBrandList2.push({})
              }
              if (temp.length === 4) {
                this.biaoBrandList2.push({})
                this.biaoBrandList2.push({})
              }
              if (temp.length === 5) {
                this.biaoBrandList2.push({})
              }
              if (res.data.body[0]) {
                this.yDatamap.yData = res.data.body[0].types
              }
              if (res.data.body[1]) {
                this.yDatamap.yData2 = res.data.body[1].types
              }
              if (res.data.body[2]) {
                this.yDatamap.yData3 = res.data.body[2].types
              }
              if (res.data.body[3]) {
                this.yDatamap.yData4 = res.data.body[3].types
              }
              if (res.data.body[4]) {
                this.yDatamap.yData5 = res.data.body[4].types
              }
              if (res.data.body[5]) {
                this.yDatamap.yData6 = res.data.body[5].types
              }

              this.$nextTick(() => {
                this.drawPie1()
              })
            } else {
              this.biaoBrandList1 = []
              this.biaoBrandList2 = []
            }
            this.detaals()
          })
        } else {
          this.dialogVisiblesfor = true
        }
      })
    },
    // 品牌详情
    brandsLIstmap() {
      // 滚动加载初始化
      this.brandsParams = {
        currentPage: 1,
        size: 100
      }
      BRANDS(this.brandsParams).then((res) => {
        if (res.data.body) {
          if (res.data.body.length < 100) {
            this.isend = true
          } else {
            this.isend = false
          }
          this.appointList = res.data.body
          this.brand = res.data.body[0].brandCode
          this.brandLogo = res.data.body[0].brandLogo
          this.bRandname = res.data.body[0].brandName
          let brandCode = res.data.body[0].brandCode
          COUNTRYBRAND({ brandCode: brandCode }).then((rem) => {
            if (rem.data.body) {
              this.industryListmapTwo = rem.data.body[0]
                ? rem.data.body[0]
                : null
              if (
                rem.data.body[0] &&
                rem.data.body[0].allianceGuestPlatformLogos
              ) {
                this.logoListLTwo =
                  rem.data.body[0].allianceGuestPlatformLogos.split(',')
              } else {
                this.logoListLTwo = []
              }
              if (rem.data.body[0] && rem.data.body[0].countryCode) {
                this.countrycode = rem.data.body[0].countryCode
              } else {
                this.countrycode = ''
              }

              this.dropdownList = rem.data.body
              if (rem.data.body.length > 0) {
                this.yDatatWO = rem.data.body[0].types
              } else {
                this.yDatatWO = []
              }
              this.$nextTick(() => {
                this.drawPie2()
              })
              this.BRANDList()
            } else {
              this.industryListmapTwo = null
              this.countrycode = ''
              this.dropdownList = []
              this.logoListLTwo = []
              this.yDatatWO = []
              this.$nextTick(() => {
                this.drawPie2()
              })
            }
          })
        }
      })
    },
    // 品牌滚动加载
    brandsLIstmapScroll() {
      if (!this.isend) {
        // 滚动加载参数
        this.brandsParams.currentPage++
        this.infiniteScrollFlag = true
        BRANDS(this.brandsParams).then((res) => {
          if (res.data.body) {
            if (res.data.body.length < 100) {
              this.isend = true
            } else {
              this.isend = false
            }
            this.appointList = this.appointList.concat(res.data.body)
            this.infiniteScrollFlag = false
            this.brand = res.data.body[0].brandCode
              ? res.data.body[0].brandCode
              : ''
            this.brandLogo = res.data.body[0].brandLogo
            this.bRandname = res.data.body[0].brandName
            let brandCode = res.data.body[0].brandCode
            COUNTRYBRAND({ brandCode: brandCode }).then((rem) => {
              if (rem.data.body) {
                this.industryListmapTwo = rem.data.body[0]
                  ? rem.data.body[0]
                  : null
                this.logoListLTwo =
                  rem.data.body[0].allianceGuestPlatformLogos.split(',')
                this.countrycode = rem.data.body[0].countryCode
                this.dropdownList = rem.data.body
                this.yDatatWO = rem.data.body[0].types
                this.$nextTick(() => {
                  this.drawPie2()
                })
                this.BRANDList()
              } else {
                this.industryListmapTwo = null
                this.countrycode = ''
                this.dropdownList = []
                this.logoListLTwo = []
                this.yDatatWO = []
                this.$nextTick(() => {
                  this.drawPie2()
                })
              }
            })
          }
        })
      } else {
        return
      }
    },
    // 分页功能
    currentchange(val) {
      this.currentPage = val
      this.currer()
    },
    currer() {
      let data = {
        country: this.country,
        propTypes: this.propTypes,
        affiliateNetworks: this.affiliateNetworks,
        currentPage: this.currentPage,
        size: this.size,
        industry: this.industry,
        name: this.aname,
        orderRule: this.orderRule,
        hasEmail: this.havaEmail1 ? '1' : ''
      }
      this.tableLoading = true
      INDUSTRYY(data)
        .then((res) => {
          this.brandsList = []
          this.total = res.data.body.total
          let arr = res.data.body.records
          arr.map((item, index) => {
            // item.follList = this.follList
            if (item.affiliateNetworkLogos) {
              item.affiliateNetworkLogos = item.affiliateNetworkLogos.split(',')
            }
            if (item.goods) {
              // item.goods = item.goods.split("#nbsp;");
              let goodsTemp = []
              let googsALL = item.goods.split('#nbsp;')
              googsALL.forEach((item) => {
                this.checkImage(item).then((img) => {
                  if (img.width > 10 && img.height > 10) {
                    goodsTemp.push(img.src)
                  }
                })
              })
              item.goods = goodsTemp
            } else {
              item.goods = []
            }
            if (item.brands) {
              item.brands = item.brands.split(',')
            }
            if (item.types) {
              item.types = item.types.split(',')
            }
            if (item.promoType) {
              item.promoType = item.promoType.split(',')
            }
            if (item.category) {
              item.category = item.category.split(',')
            }
          })
          this.brandsList = arr
          this.tableLoading = false
        })
        .catch((err) => {
          this.tableLoading = false
        })
    },
    changeSort() {
      this.currentPage = 1
      this.currer()
    },
    currentChangeTwo(val) {
      this.currentPageTwo = val
      this.currcgahn()
    },
    // 图片检查
    checkImage(src) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        img.onload = () => resolve(img)
        img.onerror = reject
        img.src = src
      })
    },
    currcgahn() {
      let data = {
        brand: this.brand,
        currentPage: this.currentPageTwo,
        size: this.sizeTwo,
        country: this.countryTwo,
        propTypes: this.propTypesTwo,
        affiliateNetworks: this.affiliateNetworksTwo,
        name: this.bname,
        orderRule: this.orderRule,
        hasEmail: this.havaEmail2 ? '1' : ''
      }
      BRAND(data).then((res) => {
        this.brandsListTwo = res.data.body.records
        this.totalTwo = res.data.body.total
        this.brandsListTwo.map((item, index) => {
          if (item.affiliateNetworkLogos) {
            item.affiliateNetworkLogos = item.affiliateNetworkLogos.split(',')
          }
          if (item.goods) {
            // item.goods = item.goods.split("#nbsp;");
            let goodsTemp = []
            let googsALL = item.goods.split('#nbsp;')
            googsALL.forEach((item) => {
              this.checkImage(item).then((img) => {
                if (img.width > 10 && img.height > 10) {
                  goodsTemp.push(img.src)
                }
              })
            })
            item.goods = goodsTemp
          } else {
            item.goods = []
          }
          if (item.brands) {
            item.brands = item.brands.split(',')
          }
          if (item.types) {
            item.types = item.types.split(',')
          }
          if (item.promoType) {
            item.promoType = item.promoType.split(',')
          }
          if (item.category) {
            item.category = item.category.split(',')
          }
        })
      })
    },
    // 行业环形图数据处理
    drawPie1() {
      let arr = []
      let arr3 = []
      let arr4 = []
      let arr5 = []
      let arr6 = []
      let arr7 = []
      if (this.yDatamap.yData) {
        this.yDatamap.yData.forEach((element) => {
          arr.push({
            value: element.value,
            id: element.id,
            name: element.type,
            color: element.element
          })
        })
      }
      if (this.yDatamap.yData2) {
        this.yDatamap.yData2.forEach((element) => {
          arr3.push({
            value: element.value,
            id: element.id,
            name: element.type,
            color: element.element
          })
        })
      }
      if (this.yDatamap.yData3) {
        this.yDatamap.yData3.forEach((element) => {
          arr4.push({
            value: element.value,
            id: element.id,
            name: element.type,
            color: element.element
          })
        })
      }
      if (this.yDatamap.yData4) {
        this.yDatamap.yData4.forEach((element) => {
          arr5.push({
            value: element.value,
            id: element.id,
            name: element.type,
            color: element.element
          })
        })
      }
      if (this.yDatamap.yData5) {
        this.yDatamap.yData5.forEach((element) => {
          arr6.push({
            value: element.value,
            id: element.id,
            name: element.type,
            color: element.element
          })
        })
      }
      if (this.yDatamap.yData6) {
        this.yDatamap.yData6.forEach((element) => {
          arr7.push({
            value: element.value,
            id: element.id,
            name: element.type,
            color: element.element
          })
        })
      }
      if (this.biaoBrandList1[0] && this.biaoBrandList1[0].brandCode) {
        let myChart = this.$echarts.init(document.getElementById('myChart0'))
        myChart.setOption({
          tooltip: {
            trigger: 'item',
            formatter: '{b} ({d}%)',
            textStyle: {
              fontSize: 14
            }
          },
          legend: {
            orient: 'horizontal',
            right: 10,
            // top: '-10%',
            icon: 'rect',
            itemGap: 10,
            x: '30%',
            y: 'center',
            itemHeight: 10, // 图例icon高度
            itemWidth: 10, // 图例icon宽度
            padding: [25, 0],
            textStyle: {
              fontSize: 10
            }
          },
          series: [
            {
              type: 'pie',
              radius: ['35%', '65%'],
              data: arr,
              color: [
                '#DDB2F9',
                '#F89589',
                '#2CD4D3',
                '#9577e5',
                '#FEC776',
                '#FC6780',
                '#7892EC',
                '#B28C68',
                '#dfb7b4',
                '#3b2e36',
                '#647e43',
                '#d0d0d0'
              ],
              itemStyle: {
                normal: {
                  label: {
                    show: false
                  },
                  labelLine: {
                    show: false
                  }
                }
              },
              center: ['15%', '50%']
            }
          ]
        })
        myChart.resize()
      }
      if (this.biaoBrandList1[1] && this.biaoBrandList1[1].brandCode) {
        let myChart3 = this.$echarts.init(document.getElementById('myChart1'))
        myChart3.setOption({
          tooltip: {
            trigger: 'item',
            formatter: '{b} ({d}%)',
            textStyle: {
              fontSize: 14
            }
          },
          legend: {
            orient: 'horizontal',
            right: 10,
            icon: 'rect',
            itemGap: 10,
            x: '30%',
            y: 'center',
            itemHeight: 10, // 图例icon高度
            itemWidth: 10, // 图例icon宽度
            padding: [25, 0],
            textStyle: {
              fontSize: 10
            }
          },
          series: [
            {
              type: 'pie',
              radius: ['35%', '65%'],
              data: arr3,
              color: [
                '#DDB2F9',
                '#F89589',
                '#2CD4D3',
                '#9577e5',
                '#FEC776',
                '#FC6780',
                '#7892EC',
                '#B28C68',
                '#dfb7b4',
                '#3b2e36',
                '#647e43',
                '#d0d0d0'
              ],
              itemStyle: {
                normal: {
                  label: {
                    show: false
                  },
                  labelLine: {
                    show: false
                  }
                }
              },
              center: ['15%', '50%']
            }
          ]
        })
        myChart3.resize()
      }
      if (this.biaoBrandList1[2] && this.biaoBrandList1[2].brandCode) {
        let myChart4 = this.$echarts.init(document.getElementById('myChart2'))
        myChart4.setOption({
          tooltip: {
            trigger: 'item',
            formatter: '{b} ({d}%)',
            textStyle: {
              fontSize: 14
            }
          },
          legend: {
            orient: 'horizontal',
            right: 10,
            icon: 'rect',
            itemGap: 10,
            x: '30%',
            y: 'center',
            itemHeight: 10, // 图例icon高度
            itemWidth: 10, // 图例icon宽度
            padding: [25, 0],
            textStyle: {
              fontSize: 10
            }
          },
          series: [
            {
              type: 'pie',
              radius: ['35%', '65%'],
              data: arr4,
              color: [
                '#DDB2F9',
                '#F89589',
                '#2CD4D3',
                '#9577e5',
                '#FEC776',
                '#FC6780',
                '#7892EC',
                '#B28C68',
                '#dfb7b4',
                '#3b2e36',
                '#647e43',
                '#d0d0d0'
              ],
              itemStyle: {
                normal: {
                  label: {
                    show: false
                  },
                  labelLine: {
                    show: false
                  }
                }
              },
              center: ['15%', '50%']
            }
          ]
        })
        myChart4.resize()
      }
      if (this.biaoBrandList2[0] && this.biaoBrandList2[0].brandCode) {
        let myChart5 = this.$echarts.init(document.getElementById('myChart3'))

        myChart5.setOption({
          tooltip: {
            trigger: 'item',
            formatter: '{b} ({d}%)',
            textStyle: {
              fontSize: 14
            }
          },
          legend: {
            orient: 'horizontal',
            right: 10,
            icon: 'rect',
            itemGap: 10,
            x: '30%',
            y: 'center',
            itemHeight: 10, // 图例icon高度
            itemWidth: 10, // 图例icon宽度
            padding: [25, 0],
            textStyle: {
              fontSize: 10
            }
          },
          series: [
            {
              type: 'pie',
              radius: ['35%', '65%'],
              data: arr5,
              color: [
                '#DDB2F9',
                '#F89589',
                '#2CD4D3',
                '#9577e5',
                '#FEC776',
                '#FC6780',
                '#7892EC',
                '#B28C68',
                '#dfb7b4',
                '#3b2e36',
                '#647e43',
                '#d0d0d0'
              ],
              itemStyle: {
                normal: {
                  label: {
                    show: false
                  },
                  labelLine: {
                    show: false
                  }
                }
              },
              center: ['15%', '50%']
            }
          ]
        })
        myChart5.resize()
      }
      if (this.biaoBrandList2[1] && this.biaoBrandList2[1].brandCode) {
        let myChart6 = this.$echarts.init(document.getElementById('myChart4'))
        myChart6.setOption({
          tooltip: {
            trigger: 'item',
            formatter: '{b} ({d}%)',
            textStyle: {
              fontSize: 14
            }
          },
          legend: {
            orient: 'horizontal',
            right: 10,
            // top: '10%',
            icon: 'rect',
            itemGap: 10,
            x: '30%',
            y: 'center',
            itemHeight: 10, // 图例icon高度
            itemWidth: 10, // 图例icon宽度
            padding: [25, 0],
            textStyle: {
              fontSize: 10
            }
          },
          series: [
            {
              type: 'pie',
              radius: ['35%', '65%'],
              data: arr6,
              color: [
                '#DDB2F9',
                '#F89589',
                '#2CD4D3',
                '#9577e5',
                '#FEC776',
                '#FC6780',
                '#7892EC',
                '#B28C68',
                '#dfb7b4',
                '#3b2e36',
                '#647e43',
                '#d0d0d0'
              ],
              itemStyle: {
                normal: {
                  label: {
                    show: false
                  },
                  labelLine: {
                    show: false
                  }
                }
              },
              center: ['15%', '50%']
            }
          ]
        })
        myChart6.resize()
      }
      if (this.biaoBrandList2[1] && this.biaoBrandList2[2].brandCode) {
        let myChart7 = this.$echarts.init(document.getElementById('myChart5'))
        myChart7.setOption({
          tooltip: {
            trigger: 'item',
            formatter: '{b} ({d}%)',
            textStyle: {
              fontSize: 14
            }
          },
          legend: {
            orient: 'horizontal',
            right: 10,
            icon: 'rect',
            itemGap: 10,
            x: '30%',
            y: 'center',
            itemHeight: 10, // 图例icon高度
            itemWidth: 10, // 图例icon宽度
            padding: [25, 0],
            textStyle: {
              fontSize: 10
            }
          },
          series: [
            {
              type: 'pie',
              radius: ['35%', '65%'],
              data: arr7,
              color: [
                '#DDB2F9',
                '#F89589',
                '#2CD4D3',
                '#9577e5',
                '#FEC776',
                '#FC6780',
                '#7892EC',
                '#B28C68',
                '#dfb7b4',
                '#3b2e36',
                '#647e43',
                '#d0d0d0'
              ],
              itemStyle: {
                normal: {
                  label: {
                    show: false
                  },
                  labelLine: {
                    show: false
                  }
                }
              },
              center: ['15%', '50%']
            }
          ]
        })
        myChart7.resize()
      }
    },
    // 品牌环形图数据处理
    drawPie2() {
      let myChart = this.$echarts.init(document.getElementById('myChart6'))
      let arr = []
      this.yDatatWO.forEach((element) => {
        arr.push({
          value: element.value,
          id: element.id,
          name: element.type,
          color: element.element
        })
      })
      myChart.setOption({
        tooltip: {
          trigger: 'item',
          formatter: '{b} ({d}%)',
          textStyle: {
            fontSize: 12
          }
        },
        legend: {
          orient: 'horizontal',
          right: 10,
          icon: 'rect',
          itemGap: 10,
          x: '60%',
          y: 'center',
          itemHeight: 15, // 图例icon高度
          itemWidth: 15, // 图例icon宽度
          padding: [35, 0],
          textStyle: {
            fontSize: 10
          }
        },
        title: {
          text: '',
          left: 'center',
          textStyle: {
            color: '#999',
            fontWeight: 'normal',
            fontSize: 12
          }
        },
        series: [
          {
            // name: arr,
            type: 'pie',
            radius: ['35%', '65%'],
            // roseType:'area', // 是否显示成南丁格尔图，默认false
            data: arr,
            color: [
              '#DDB2F9',
              '#F89589',
              '#2CD4D3',
              '#9577e5',
              '#FEC776',
              '#FC6780',
              '#7892EC',
              '#B28C68',
              '#dfb7b4',
              '#3b2e36',
              '#647e43',
              '#d0d0d0'
            ],
            itemStyle: {
              normal: {
                label: {
                  show: false
                },
                labelLine: {
                  show: false
                }
              }
            },
            labelLine: {
              length: 5
            },
            // label: {
            //   normal: {
            //     textStyle: {
            //       fontSize: 12
            //     }
            //   },
            // },
            center: ['30%', '50%']
          }
        ]
      })
      myChart.resize()
    },
    // 所有0国家,1类型,2平台 行业
    all(e) {
      this.currentPage = 1
      if (e == 0) {
        this.countryListStuts = -1
        this.country = ''
        this.detaals()
      } else if (e == 1) {
        this.countryListStutstwo = -1
        this.propTypes = ''
        this.detaals()
      } else if (e == 2) {
        this.countryListStutsshr = -1
        this.affiliateNetworks = ''
        this.detaals()
      }
    },
    // 选择筛选国家
    titLrestus(e, index) {
      this.currentPage = 1
      this.countryListStuts = index
      this.country = e.code
      this.detaals()
    },
    // 选择筛选类型
    titLrestusTwo(e, index) {
      this.currentPage = 1
      this.countryListStutstwo = index
      this.propTypes = e.code
      this.detaals()
    },
    // 选择筛选平台
    titLrestusShr(e, index) {
      this.currentPage = 1
      this.countryListStutsshr = index
      this.affiliateNetworks = e.code
      this.detaals()
    },
    // 行业详情
    detaals() {
      let data = {
        country: this.country,
        propTypes: this.propTypes,
        affiliateNetworks: this.affiliateNetworks,
        currentPage: this.currentPage,
        size: this.size,
        industry: this.industry,
        name: this.aname,
        orderRule: this.orderRule,
        hasEmail: this.havaEmail1 ? '1' : ''
      }
      INDUSTRYY(data).then((res) => {
        if (res.data.code == 'error') {
          this.$message.error(res.data.msg)
        } else {
          this.brandsList = []
          this.total = res.data.body.total
          let arr = res.data.body.records
          arr.map((item) => {
            this.brandsList.push(item)
          })
          this.brandsList.map((item, index) => {
            if (item.affiliateNetworkLogos) {
              item.affiliateNetworkLogos = item.affiliateNetworkLogos.split(',')
            }
            if (item.goods) {
              // item.goods = item.goods.split("#nbsp;");
              let goodsTemp = []
              let googsALL = item.goods.split('#nbsp;')
              googsALL.forEach((item) => {
                this.checkImage(item).then((img) => {
                  if (img.width > 10 && img.height > 10) {
                    goodsTemp.push(img.src)
                  }
                })
              })
              item.goods = goodsTemp
            } else {
              item.goods = []
            }
            if (item.brands) {
              item.brands = item.brands.split(',')
            }
            if (item.types) {
              item.types = item.types.split(',')
            }
            if (item.promoType) {
              item.promoType = item.promoType.split(',')
            }
            if (item.category) {
              item.category = item.category.split(',')
            }
          })
        }
      })
    },
    // 所有0国家,1类型,2平台 行业
    allTwo(e) {
      this.currentPageTwo = 1
      if (e == 0) {
        this.barndListStuts = -1
        this.countryTwo = ''
        this.BRANDList()
      } else if (e == 1) {
        this.barndListStutstwo = -1
        this.propTypesTwo = ''
        this.BRANDList()
      } else if (e == 2) {
        this.barndListStutsshr = -1
        this.affiliateNetworksTwo = ''
        this.BRANDList()
      }
    },
    // 选择筛选国家
    brandrestus(e, index) {
      this.currentPageTwo = 1
      this.barndListStuts = index
      this.countryTwo = e.code
      this.BRANDList()
    },
    // 选择筛选类型
    brandrestusTwo(e, index) {
      this.currentPageTwo = 1
      this.barndListStutstwo = index
      this.propTypesTwo = e.code
      this.BRANDList()
    },
    // 选择筛选平台
    brandrestusShr(e, index) {
      this.currentPageTwo = 1
      this.barndListStutsshr = index
      this.affiliateNetworksTwo = e.code
      this.BRANDList()
    },
    // 品牌详情
    BRANDList() {
      // this.brandsListTwo = [];
      let data = {
        brand: this.brand,
        currentPage: this.currentPageTwo,
        size: this.sizeTwo,
        country: this.countryTwo,
        propTypes: this.propTypesTwo,
        affiliateNetworks: this.affiliateNetworksTwo,
        name: this.bname,
        orderRule: this.orderRule,
        hasEmail: this.havaEmail2 ? '1' : ''
      }
      BRAND(data).then((res) => {
        if (res.data.body) {
          this.brandsListTwo = []
          this.totalTwo = res.data.body.total
          let arr = res.data.body.records
          arr.map((item) => {
            if (item.affiliateNetworkLogos) {
              item.affiliateNetworkLogos = item.affiliateNetworkLogos.split(',')
            }
            if (item.goods) {
              // item.goods = item.goods.split("#nbsp;");
              let goodsTemp = []
              let googsALL = item.goods.split('#nbsp;')
              googsALL.forEach((item) => {
                this.checkImage(item).then((img) => {
                  if (img.width > 10 && img.height > 10) {
                    goodsTemp.push(img.src)
                  }
                })
              })
              item.goods = goodsTemp
            } else {
              item.goods = []
            }
            if (item.brands) {
              item.brands = item.brands.split(',')
            }
            if (item.types) {
              item.types = item.types.split(',')
            }
            if (item.promoType) {
              item.promoType = item.promoType.split(',')
            }
            if (item.category) {
              item.category = item.category.split(',')
            }
            this.brandsListTwo = arr
          })
        }
      })
    },
    changeSortBrand() {
      this.currentPageTwo = 1
      this.BRANDList()
    },
    // 点击切换效果
    detaliqx(index) {
      this.detaliStuts = index
    },
    detaliqxtwo(index) {
      this.detaliStutstwo = index
    },
    // 点击展示更多国家
    feedtype(e) {
      if (e == 1) {
        this.feed = true
      } else {
        this.feed = false
      }
    },
    // 点击展示更多类型
    feedtypetwo(e) {
      if (e == 1) {
        this.feedTwo = true
      } else {
        this.feedTwo = false
      }
    },
    // 点击展示更多平台
    feedtypesher(e) {
      if (e == 1) {
        this.feedsher = true
      } else {
        this.feedsher = false
      }
    },
    // 点击展示更多国家
    brandtype(e) {
      if (e == 1) {
        this.brandfeed = true
      } else {
        this.brandfeed = false
      }
    },
    // 点击展示更多类型
    brandtypetwo(e) {
      if (e == 1) {
        this.brandfeedTwo = true
      } else {
        this.brandfeedTwo = false
      }
    },
    // 点击展示更多平台
    brandtypesher(e) {
      if (e == 1) {
        this.brandfeedsher = true
      } else {
        this.brandfeedsher = false
      }
    },
    permitsList() {
      QUERYSELECTLIST().then((res) => {
        this.countryList = res.data.body.countryList
        this.countryListTwo = res.data.body.countryList
        this.typeList = res.data.body.typeList
        this.typeListTwo = res.data.body.typeList
        this.screenList = res.data.body.platformList
        this.screenListTwo = res.data.body.platformList
      })
    },
    // 隐私政策 英文版
    test3() {
      let routeUrl = this.$router.resolve({
        path: '/influencerse'
      })
      window.open(routeUrl.href)
    },
    // 关注
    joingroup(e, i) {
      let userGroups = [
        {
          groupCode: 'concern001',
          allianceCode: e.allianceCode
        }
      ]
      JOINGROUP({ userGroups }).then((res) => {
        if (res.data.code == 'success') {
          this.$message({
            message: '已关注',
            type: 'success'
          })
          if (i == 1) {
            this.detaals()
          } else {
            this.BRANDList()
          }
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 取消关注
    cancelgroup(e, i) {
      REMOVEGROUPONEDETAIL({
        groupCode: 'concern001',
        allianceCode: e.allianceCode
      }).then((res) => {
        if (res.data.code == 'success') {
          this.$message({
            message: '已取消关注',
            type: 'success'
          })
          if (i == 1) {
            this.detaals()
          } else {
            this.BRANDList()
          }
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 发送邮件
    childMethod(e) {
      if (e.hasEmail == 1) {
        CHECKBATCHSENDEMAIL({ allianceCodes: [e.allianceCode] }).then((res) => {
          if (res.data.code === 'success') {
            if (res.data.body.sendEmailCount > 0) {
              this.$router.push({
                path: 'emailConnection',
                query: { allianceCode: e.allianceCode, name: e.name }
              })
              localStorage.setItem('isSelect', 3)
            } else {
              this.$message.warning(
                '为了避免打扰，且营造一个友好合作环境，系统将限制发送给同一联盟客的邮件数量为每7天1封。您已经在过去的7天内向此合作伙伴发送过电子邮件。请稍后再试。'
              )
            }
          }
        })
      }
    },

    // 加入到分组
    addgrouping(e, i) {
      this.comstuts = i
      this.queryUserGroup()
      this.allianceCode = e.allianceCode
      this.follListTwo = []
      QUERY().then((res) => {
        if (res.data.code == 'success') {
          QUERYHASGROUP({ allianceCode: e.allianceCode }).then((res) => {
            if (res.data.body.length === this.follList.length) {
              this.$message.warning(
                '暂无可添加的分组,您可以到我的关注页面添加新的分组'
              )
            } else {
              this.groupingstuts = true
              let ary02 = res.data.body
              for (var i = 0; i < this.follList.length; i++) {
                for (var j = 0; j < ary02.length; j++) {
                  if (this.follList[i].groupCode == ary02[j]) {
                    this.follList[i] = ''
                    break
                  }
                }
              }
              for (var i = 0; i < this.follList.length; i++) {
                if (this.follList[i] != '') {
                  this.follListTwo.push(this.follList[i])
                }
              }
            }
          })
        } else {
          this.$router.push('./')
        }
      })
    },
    delCooperate(e, i) {
      REMOVEGROUPONEDETAIL({
        groupCode: 'cooperate001',
        allianceCode: e.allianceCode
      }).then((res) => {
        if (res.data.code == 'success') {
          // this.allianceDetailPart1()
        } else {
          this.$message.error(res.data.msg)
        }

        if (i == 1) {
          this.detaals()
        } else {
          this.BRANDList()
        }
      })
    },
    addCooperate(e, i) {
      let userGroups = [
        {
          groupCode: 'cooperate001',
          allianceCode: e.allianceCode
        }
      ]
      JOINGROUP({ userGroups }).then((res) => {
        if (res.data.code == 'success') {
          // this.allianceDetailPart1()
        } else {
          this.$message.error(res.data.msg)
        }
        if (i == 1) {
          this.detaals()
        } else {
          this.BRANDList()
        }
      })
    },
    // 查看详情
    godetil(e) {
      let routeUrl = this.$router.resolve({
        path: 'details',
        query: { code: e.allianceCode }
      })
      window.open(routeUrl.href, '_blank')
    },
    // changeEmail(type) {
    //   if (this.havaEmail === "") {
    //     this.havaEmail = "1";
    //   } else {
    //     this.havaEmail = "";
    //   }
    //   if (type == 1) {
    //     this.currer();
    //   } else {
    //     this.BRANDList();
    //   }
    // },
    changeEmail1(e) {
      this.currentPage = 1
      this.currer()
    },
    changeEmail2(e) {
      this.currentPageTwo = 1
      this.BRANDList()
    },

    rightclick(event) {
      this.rightclickInfo = {
        position: {
          x: event.clientX,
          y: event.clientY
        },
        menulists: [
          {
            fnName: 'copy',
            params: { event },
            icoName: 'el-icon-document-copy',
            btnName: 'copy'
          }
        ]
      }
      event.preventDefault() // 阻止默认的鼠标右击事件
    },
    hanldeRightClick(params) {
      this.$refs.appealModal.init(params)
    }
  }
}
</script>
<style lang="less" scoped>
.logos_box {
  align-items: center;
  gap: 5px;

  img {
    width: 22px;
  }
}

/deep/ textarea {
  padding-right: 45px;
  height: 100% !important;
  border-radius: 10px !important;
}

::-webkit-scrollbar {
  width: 0px !important;
  height: 0px !important;
  background-color: #fff;
}

.aibox {
  position: fixed;
  display: flex;
  flex-direction: row;
  height: 100%;
  min-height: 500px;
  border-radius: 10px 0 0 10px;
  box-shadow: 1px 0 2px 2px #ecf5ff;
  top: 0;
  right: 0;
  z-index: 999 !important;
  background-color: #f8e4eb;
  box-sizing: border-box;

  #aibtn {
    position: absolute;
    width: 75px;
    height: 75px;
    top: 10%;
    left: -75px;
    text-align: center;
    cursor: pointer;
    border-radius: 50% 0% 0% 50%;
    background-color: #f8e4eb;
    z-index: 9999 !important;

    .block1 {
      width: 16px;
      height: 16px;
      z-index: 9998 !important;
      position: absolute;
      right: 0;
      top: -16px;

      #aiblock1 {
        width: 100%;
      }
    }

    .block2 {
      width: 16px;
      height: 16px;
      z-index: 9998 !important;
      position: absolute;
      right: 0px;
      bottom: -15px;

      #aiblock2 {
        width: 100%;
      }
    }

    #bot {
      width: 50px;
      margin-top: 22px;
    }
  }
}

#aibtn3 {
  position: fixed;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #34e7e7;
  right: 20px;
  bottom: 150px;
  z-index: 9999 !important;
  cursor: pointer;

  img {
    margin-top: 8px;
    width: 100%;
  }

  &:hover {
    transform: scale(1.3);
    transition: all 0.4s;
  }

  @keyframes aiaction2 {
    100% {
      scale: (1.3);
    }
  }

  @keyframes aiaction {
    0%,
    50% {
      transform: translateY(-20px);
    }

    25%,
    75% {
      transform: translateY(0);
    }
  }
}

.left {
  width: 200px;
  border-right: 2px solid #fff;
}

.addchat {
  height: 80px;
  width: 250px;
  position: absolute;
  bottom: 0;
  padding: 20px 20px 20px 25px;

  .addbtn {
    width: 150px;
    height: 40px;
    border: 5px solid transparent;
    border-radius: 10px;
    background-image: linear-gradient(to right, #fff, #fff),
      linear-gradient(to right, red, #578aef);
    background-color: #d4f1ff;
  }
}

.right {
  width: 375px;
  height: 100%;

  .messageTip {
    padding: 0 15px;
    height: 60px;
    line-height: 60px;
    position: absolute;
    text-align: center;
    z-index: 999;
    top: 40%;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 8px;
    background-color: #be3c6e;
    color: #fff;
    font-weight: bold;
  }
}

.title {
  position: relative;
  // top: 0;
  color: #fff;
  width: 100%;
  height: 50px;
  line-height: 50px;
  text-align: center;
  background: linear-gradient(to right, #a9b7c5 50%, rgba(190, 60, 110, 1));

  .top-minus {
    height: 50px;
    line-height: 50px;
    font-size: 20px;
    font-weight: 600;
    position: absolute;
    right: 40px;
    top: 0;
    cursor: pointer;
    color: #fff;
  }

  .top-close {
    height: 50px;
    line-height: 50px;
    font-size: 20px;
    font-weight: 600;
    position: absolute;
    right: 10px;
    top: 0;
    cursor: pointer;
    color: #fff;
  }
}

.contentbox {
  box-sizing: border-box;
  width: 100%;
  height: calc(100% - 170px);
  flex-grow: 2;
  overflow: hidden;
  overflow-y: scroll;

  .loadingbox {
    width: 50px;
  }

  .loadingbox > div {
    width: 10px;
    height: 10px;
    background-color: #33e5e5;
    border-radius: 50%;
    display: inline-block;
    animation: action 1.5s infinite ease-in-out;
    animation-fill-mode: both;
  }

  .loadingbox .point1 {
    animation-delay: -0.3s;
  }

  .loadingbox .point2 {
    animation-delay: -0.1s;
  }

  @keyframes action {
    0%,
    80%,
    100% {
      transform: scale(0);
    }

    40% {
      transform: scale(1);
    }
  }
}

.chat-list {
  display: flex;
  flex-direction: column;
  width: 90%;
  margin: 0 auto;
  margin-top: 1rem;
  margin-bottom: 1rem;
  overflow: auto;

  .tastrule_center {
    white-space: pre-wrap;
  }

  > div {
    display: flex;
    margin-top: 1rem;

    > div {
      max-width: 250px;
      padding: 0.6rem;
      opacity: 0.8;

      font-size: 0.9rem;
      font-family: FZLanTingHei-L-GBK;
      font-weight: 400;
      color: #c5e7ff;
      text-align: start;
    }

    .bot {
      padding: 10px 9px;
      letter-spacing: 0.5px;
      font-weight: 500;
      font-size: 14px;
      font-family: Verdana, Arial, Helvetica, sans-serif;
      align-self: flex-end;
      background: #fff;
      color: #000;
      border-radius: 16px 16px 16px 16px;
      text-transform: uppercase;
    }

    .user {
      color: #fff;
      background-color: #be3c6e;
      padding: 10px 9px;
      letter-spacing: 0.5px;
      font-weight: 500;
      font-size: 14px;
      font-family: Verdana, Arial, Helvetica, sans-serif;
      align-self: flex-start;
      border-radius: 16px 16px 16px 16px;
    }

    .img1 {
      width: 50px;
    }

    .img2 {
      width: 2rem;
      height: 2rem;
      margin-left: 1rem;
    }
  }

  > .botbox {
    align-self: flex-start;
  }

  > .userbox {
    align-self: flex-end;
  }
}

.el-textarea {
  position: absolute;
  height: 100px;
  width: 94%;
  bottom: 8px;
  right: 3%;
}

.mg {
  margin-right: 20px;
}

.mr30 {
  margin-right: 30px;
}

.pages {
  margin: 20px 0;
}

.topArea {
  margin: 20px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .email {
    height: 32px;
    padding: 5px;
    border-radius: 2px;

    // border: 0.0625rem solid #dcdfe6;
    img {
      height: 100%;
      cursor: pointer;
      // transform: translateY(2px);
    }
  }
}

.category {
  margin: 0 15px;
  // padding: 20px 0;
  width: 400px;
  padding-left: 15px;
  margin-right: 70px;

  div {
    display: flex;

    .category_tt {
      display: flex;
      height: 25px;
      align-items: center;
      margin-right: 12px;
    }

    .category_butt {
      min-width: 80px;
      height: 25px;
      line-height: 25px;
      background: #d8dee8;
      margin-right: 15px;
    }

    .foll_tt_top {
      text-overflow: ellipsis;
      white-space: nowrap;

      .foll_tt {
        height: 25px;
        line-height: 25px;
        // margin-right: 17px;
      }
    }
  }
}

.foll_tt_d {
  width: 230px;
  max-height: 100px;
  overflow: auto;
  flex-wrap: wrap;
}

.foll_tt_d::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background: #a6a8bf;
}

.foll_tt_d::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  border-radius: 10px;
  background: #ededed;
}

.foll_tt_d::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}

.foll_tt_t {
  height: 25px;
  line-height: 25px;
  width: 30%;

  img {
    height: 25px;
  }
}

.mr {
  margin-right: 10px;
}

.h25 {
  height: 25px;
  line-height: 25px;
}

.top_input {
  height: 55px;
  position: fixed;
  top: 0;
  left: 255px;
  z-index: 998;
  align-items: center;

  .unmaeinput {
    width: 450px;
    height: 55px;
    line-height: 55px;
    position: relative;

    .el-input {
      height: 55px !important;
      line-height: 55px !important;

      .el-input__inner {
        height: 55px !important;
        line-height: 55px !important;
      }
    }

    .icons {
      width: 16px;
      height: 66px;
      position: absolute;
      left: 5px;
      top: -5px;
      display: flex;
      align-items: center;

      img {
        width: 16px;
        height: 16px;
      }
    }
  }

  .searchs {
    width: 56px;
    height: 28px;
    line-height: 28px;
  }
}

.top_input_list {
  position: fixed;
  top: 60px;
  left: 235px;
  z-index: 9999;
  width: 450px;
  height: 500px;
  overflow-y: scroll;
  box-shadow: 0px 0px 20px 1px rgba(0, 0, 0, 0.05);

  .list {
    width: 100%;
    padding: 0 30px;

    .contern {
      width: 100%;
      height: 40px;
      line-height: 40px;
      border-bottom: 1px solid #e7e8f2;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 12px;
    }

    span {
      color: #ccc;
      display: inline-block;
    }
  }

  .list:hover {
    background: rgba(0, 0, 0, 0.05);
  }
}

.mb6 {
  margin-bottom: 10px;
}

.mb8 {
  margin-bottom: 15px;
}

.mt8 {
  margin-top: 8px;
}

.titnames {
  min-width: 120px;
}

.labelbox {
  min-width: 40px;
}

.foll_title_div {
  width: 100% !important;
  height: 100% !important;
  flex-wrap: wrap !important;
  overflow: auto !important;
}

.foll_title_div::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background: #a6a8bf;
}

.foll_title_div::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  border-radius: 10px;
  background: #ededed;
}

.foll_title_div::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}

.foll_title {
  // width: 540px;
  white-space: nowrap;
  /*不让文本换行,在一行显示*/
  position: relative;

  .foll_title_rigg {
    max-width: 300px;
    height: 100px;
    // background: #404040;
    z-index: 1;
  }

  // background: #fafafd;
  p {
    height: 25px;
    line-height: 25px;
    padding: 0 10px;
    margin-right: 5px;
  }

  .ttres {
    max-width: 70px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .zanwe {
    width: 60px;
    height: 25px;
    background-image: linear-gradient(90deg, hsla(0, 0%, 100%, 0), #fff);
    position: absolute;
    right: 0;
    top: 0;
  }
}

.foll_title_top {
  display: flex;
  flex-wrap: wrap;
  padding-right: 50px;
  box-sizing: border-box;
  min-width: calc((100% - 10px) / 3);

  p {
    margin-right: 10px;
    margin-bottom: 20px;
    width: calc((100% - 10px) / 3);
    min-width: calc((100% - 1px) / 3);
    max-width: calc((100% - 10px) / 3);
    padding: none;
  }
}

.cuttingtop {
  width: 100%;
  min-width: 920px;
  height: 100%;
  background: #fafafd;
}

.yesemil {
  background: #be3c6e;
  color: #fff;
  cursor: pointer;
}

.noemail {
  color: #000;
  background: #404040;
  opacity: 0.5;
  cursor: not-allowed;
}

.markba {
  background: rgba(166, 168, 191, 25%);
  color: #000;
}

.marba2 {
  background: #fff;
}

.borre {
  border: 2px solid #be3c6e;
}

@media screen and (min-width: 1000px) and (max-width: 2250px) {
  .cuttings {
    width: 1600px;
    margin: 0 auto;
    box-sizing: border-box;
    background: #fafafd;
  }

  .foll_title {
    width: 460px;
  }
}

@media screen and (min-width: 2250px) and (max-width: 3000px) {
  .cuttings {
    width: 1920px;
    margin: 0 auto;
    box-sizing: border-box;
    background: #fafafd;
  }

  .foll_title {
    width: 700px;
  }
}

.top1_butt {
  width: 100%;
  height: 70px;
  margin: 0 auto;

  .top1_privacy {
    height: 100%;
    line-height: 50px;

    a {
      color: #000;
      border-bottom: 1px solid #000;
      padding-bottom: 5px;
    }
  }
}

.top1_butt_b {
  width: 100px;
}

.mail {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5, #000);
  z-index: 10;

  .mail_center {
    width: 440px;
    height: 390px;
    background: #ffffff;
    position: absolute;
    bottom: 50px;
    right: 50px;
    padding: 20px;
    border-radius: 15px 15px 15px 15px;

    .mail_center_icon {
      width: 100%;
      text-align: right;
      margin-top: 20px;
      font-size: 26px;
      padding-right: 10px;

      i {
        font-size: 26px;
      }
    }

    .mail_center_icon_input {
      border-bottom: 1px solid rgba(64, 64, 64, 0.24);
    }

    .mail_mail {
      width: 100%;
      height: 60px;
      display: flex;

      .mail_mail_1 {
        width: 80%;
        height: 100%;
        line-height: 60px;
        font-size: 20px;
      }

      .mail_mail_2 {
        width: 20%;
        height: 100%;
        position: relative;

        img {
          width: 30px;
          height: 30px;
          position: relative;
          top: 50%;
          right: -40px;
          margin-top: -15px;
        }
      }
    }
  }

  .nologins_title {
    width: 400px;
    height: 400px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -200px;
    margin-left: -200px;
    background: #fff;
    border-radius: 15px;
    padding: 15px;
  }

  .nologins_title_icon {
    text-align: right;
    width: 100%;
    font-size: 26px;
    padding-right: 10px;

    i {
      color: #000;
    }
  }

  .nologins_title_img {
    width: 200px;
    height: 200px;
    margin: 0 auto;
    margin-top: 10px;

    img {
      width: 200px;
      height: 200px;
      display: inline-block;
      margin: 0 auto;
    }
  }

  .nologins_title_text {
    width: 100%;
    margin-top: 20px;
  }
}

div {
  box-sizing: border-box;
}

.details {
  // 联盟客详情
  width: 99%;
  word-wrap: break-word;
  word-break: break-all;
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  .details_one {
    width: 45%;
    height: 320px;
    background: #fff;
    margin-bottom: 40px;
    border-radius: 5px;
    display: flex;
    justify-content: space-around;

    .details_one_l {
      width: 40%;
      padding: 25px 0;
      // display: inline-block;
      box-sizing: border-box;

      .details_img {
        width: 150px;
        height: 150px;
        margin: 0 auto;
        border-radius: 50%;
        margin-bottom: 40px;

        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }

      .p1 {
        margin-bottom: 10px;
        font-size: 30px;
      }

      .p2 {
        font-size: 18px;
      }
    }

    .details_one_r {
      position: relative;
      width: 60%;
      padding: 25px 0;
      box-sizing: border-box;
      // display: inline-block;
      height: 100%;

      .details_one_r_t {
        height: 60%;

        .details_one_r_d1 {
          font-size: 26px;
        }
      }

      .details_one_r_b {
        .details_one_r_d1 {
          font-size: 26px;
        }
      }

      .details_one_p {
        height: 70px;
        line-height: 70px;
      }

      .details_one_img {
        padding-top: 45px;
        overflow: hidden;
        width: 80%;

        .details_log {
          margin-right: 40px;

          img {
            width: 120px;
            height: 30px;
          }
        }
      }

      .details_gd {
        position: absolute;
        right: 50px;
        bottom: 25px;
      }
    }
  }

  .more_img {
    width: 100%;
    height: 50px;
    padding: 0 20px;
    margin: 20px 0;
    box-sizing: border-box;

    img {
      width: 100%;
      height: 100%;
    }
  }
}

.cutting {
  box-sizing: border-box;

  .tbpage {
    margin-bottom: 5px;

    div {
      line-height: 30px;
      font-size: 16px;
      color: #000;
      margin-right: 50px;
      font-weight: bold;
    }

    .tbpage_bag {
      color: #be3c6e;
      border-bottom: 2px solid #be3c6e;
    }
  }

  .industry {
    width: 100%;
    // height: 30px;
    margin-top: 10px;

    div {
      line-height: 30px;
    }

    display: flex;

    .industry_tit {
      min-width: 70px;
    }

    .industry_titlist {
      width: 97%;
      // height: 30px;
      flex-wrap: wrap;
    }

    .industry_list {
      height: 100%;
      height: 30px;
      background: #fff;
      border-radius: 3px 3px 3px 3px;
      color: #000;
      margin-right: 32px;
      padding: 0 20px;
      margin-bottom: 10px;
    }

    .industrybag {
      background: rgba(168, 168, 191, 0.25);
      // color: #fff;
    }
  }

  .tit_bt {
    margin-top: 10px;
    margin-bottom: 10px;
    display: inline-block;
  }

  .tit_bt_identification {
    width: 300px;
    display: inline-block;
    position: relative;

    p {
      display: inline-block;
      position: absolute;
      top: -15px;
      margin: 0 5px;
    }

    .question {
      width: 15px;
      height: 15px;
      font-size: 12px;
      line-height: 15px;
      border: 1px solid #707070;
      color: #707070;
      margin-right: 5px;
    }

    .text {
      font-size: 12px;
      color: #707070;
      left: 25px;
      width: 500px;
    }
  }

  .carouselpp {
    width: 100%;
  }

  .switchel {
    width: 100%;
    margin-top: 10px;
    justify-content: center;
    height: 30px;
    i {
      margin: 0 10px;
    }

    .coco {
      color: rgba(190, 60, 110, 0.25);
    }
  }

  .itemswpe {
    width: 100%;
    height: 100%;
    justify-content: space-between;
    gap: 25px;

    .item_list {
      width: 33%;
      height: 700px;
      background: #fff;
      box-shadow: 0px 0px 30px 1px rgba(0, 0, 0, 0.05);

      .item_list_img {
        width: 100%;

        img {
          width: 100%;
        }
      }

      .item_conten {
        width: 100%;
        padding: 5px 0;
        padding-left: 14px;
        // border-top: 1px solid rgba(168, 168, 191, 0.25);

        .Charthy {
          width: 100%;
          height: 150px;
        }

        .chartssdf {
          width: 130px;
          height: 130px;
        }

        .item_tit {
          width: 100%;

          .item_tit_img {
            width: 40px;
            height: 40px;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .item_tit_text {
            height: 40%;
            line-height: 40px;
            font-weight: bold;

            span {
              display: inline-block;
              margin-left: 20px;
              color: #707070;
            }
          }
        }

        .item_conten_zb {
          width: 100%;
          margin-top: 10px;

          .item_conten_one {
            width: 40%;
          }

          .item_conten_two {
            width: 26%;
          }
        }

        .item_type {
          margin-top: 20px;
        }

        .ptlist {
          margin-top: 15px;
          width: 100%;

          .ptlist_title {
            width: 90px;
          }

          .imglist {
            flex: 1;
            max-height: 120px;
            flex-wrap: wrap;
            overflow: auto;
            position: relative;

            div {
              display: flex;
              margin-bottom: 13px;
              width: 33.3%;

              img {
                height: 25px;
              }
            }

            .imglistcs {
              position: absolute;
              top: 75px;
              right: 50px;
            }
          }

          .imglist::-webkit-scrollbar-thumb {
            /*滚动条里面小方块*/
            border-radius: 10px;
            background: #a6a8bf;
          }

          .imglist::-webkit-scrollbar-track {
            /*滚动条里面轨道*/
            border-radius: 10px;
            background: #ededed;
          }

          .imglist::-webkit-scrollbar {
            /*滚动条整体样式*/
            width: 4px;
            /*高宽分别对应横竖滚动条的尺寸*/
            height: 1px;
          }
        }
      }
    }
  }

  .mark {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-start;
    max-height: 300px;
    overflow: auto;

    /* 滚动条优化 start */
    &::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }

    &::-webkit-scrollbar-track {
      background: #f6f6f6;
      border-radius: 2px;
    }

    &::-webkit-scrollbar-thumb {
      background: #cdcdcd;
      border-radius: 2px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: #747474;
    }

    &::-webkit-scrollbar-corner {
      background: #f6f6f6;
    }

    /* 滚动条优化 end */

    .mark_list {
      width: 15%;
      height: 40px;
      position: relative;
      margin-bottom: 10px;
      line-height: normal;

      .mark_list_img {
        width: 20%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 10px;
        border-radius: 5px;

        .ttiimg {
          width: 25px;
          height: 25px;

          img {
            height: 100%;
          }
        }
      }

      .text {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        .text_cenbter {
          width: 80%;
          min-width: 60px;
          height: 100%;
          line-height: 2.5rem;
          margin-left: 0.3125rem;
          padding-right: 22px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;

          p {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: 12px;
          }
        }
      }

      .mark_icon {
        position: absolute;
        top: 50%;
        margin-top: -12px;
        right: 10px;

        i {
          font-size: 16px;
        }
      }
    }

    .empty {
      visibility: hidden;
      width: 15%;
      height: 0px;
    }
  }

  .mark::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    background: #a6a8bf;
  }

  .mark::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    border-radius: 10px;
    background: #ededed;
  }

  .mark::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 4px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }

  .let_one_p_name {
    max-width: 166px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .tab {
    width: 100%;
    height: 400px;
    background: #fff;
    box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.1);
    border: 1px solid #e6eaee;
    display: flex;

    .tab_left {
      width: 54%;
      height: 100%;
      padding: 35px 0 35px 15px;
      position: relative;

      .tettext {
        height: 50px;
        align-items: center;

        .tettext_list {
          min-width: 250px;
          height: 100%;
          align-items: center;
        }

        p {
          display: inline-block;
          height: 100%;
          line-height: 50px;
        }

        span {
          display: inline-block;
          height: 100%;
          line-height: 50px;
        }
      }

      .titles {
        width: 100%;

        .ttsit {
          width: 10%;
        }

        .tab_left_img_list {
          width: 90%;
          flex-wrap: wrap;
          overflow: auto;
        }
      }

      .tab_left_img_t {
        height: 30px;
        margin-right: 30px;
        margin-bottom: 30px;

        img {
          height: 100%;
        }
      }

      .tab_left_pt_img::-webkit-scrollbar-thumb {
        /*滚动条里面小方块*/
        border-radius: 10px;
        background: #fff;
      }

      .tab_left_pt_img::-webkit-scrollbar-track {
        /*滚动条里面轨道*/
        border-radius: 10px;
        background: #fff;
      }

      .tab_left_pt_img::-webkit-scrollbar {
        /*滚动条整体样式*/
        width: 2px;
        /*高宽分别对应横竖滚动条的尺寸*/
        height: 1px;
      }
    }

    .tab_left::after {
      content: '';
      width: 1px;
      height: 300px;
      background: #e7e8f2;
      position: absolute;
      right: 0;
      top: 50%;
      margin-top: -125px;
    }

    .tab_right {
      width: 46%;
      height: 100%;
      padding: 26px 0 15px 0;
      box-sizing: border-box;
      display: flex;

      .tab_right_text {
        height: 100%;
        width: 23%;

        div {
          height: 33.3%;
        }

        .tab_right_p {
          color: #000;
          font-size: 16px;
        }
      }

      .tab_right_img {
        width: 100%;
        height: 100%;
        position: relative;

        .tab_right_img_p {
          width: 100%;
          font-size: 16px;
          box-sizing: border-box;
          padding-left: 15px;
        }

        .tab_right_img_cha {
          width: 100%;
          height: 100%;
          // padding-top: 20px;
          display: flex;
          justify-content: center;

          // align-items: center;
          .charts {
            width: 90%;
            min-height: 300px;
            margin-left: -30px;
          }
        }
      }
    }
  }

  background: #fafafa;

  .con_title {
    width: 100%;
    height: 92px;
    text-align: left;
    line-height: 92px;
    font-size: 30px;

    .con_gj {
      width: 100%;
      position: relative;
      line-height: 92px;

      .con_gj_img {
        width: 51px;
        height: 51px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .con_gj_hx {
        width: 25px;
        position: absolute;
        left: 61px;
        top: -24px;

        p {
          width: 100%;
          height: 3px;
          background: #be3c6e;
          margin-bottom: 4px;
          border-radius: 5px;
        }
      }
    }
  }

  .mystyle {
    word-wrap: break-word;
    overflow: hidden;
  }

  .center_tit {
    width: 72%;
    font-size: 18px;
    margin: 16px 0;
    align-items: center;

    .text {
      margin-right: 40px;
    }

    .cent_input {
      width: 300px;
      position: relative;

      .icons {
        width: 16px;
        height: 16px;
        position: absolute;
        left: 10px;
        top: 50%;
        margin-top: -10px;

        img {
          width: 16px;
          height: 16px;
        }
      }
    }

    .searchname {
      width: 97px;
      height: 40px;
      line-height: 40px;
      margin-left: 10px;
    }
  }

  .center_tit_con {
    width: 99%;
    font-size: 16px;

    .center_tit_gj {
      width: 100%;
      display: flex;

      .center_tit_let {
        display: flex;
        width: 15%;
        height: 50px;
        line-height: 50px;

        div {
          width: 50%;
        }
      }

      .center_tit_lre {
        width: 85%;
        display: flex;
        min-width: calc((100% - 10px) / 7);
        overflow: hidden;

        div {
          // flex: 1;
          cursor: pointer;
          width: 20%;
          height: 50px;
          line-height: 50px;
          width: calc((100% - 10px) / 7);
          min-width: calc((100% - 1px) / 7);
          max-width: calc((100% - 10px) / 7);
          display: flex;
          align-items: center;
          justify-content: center;

          p {
            height: 24px;
            line-height: 24px;
            padding: 1px 10px;
          }
        }
      }

      .center_stuts {
        flex-wrap: wrap;
      }

      .center_tit_rig {
        width: 10%;
        text-align: right;
        color: #be3c6e;
        line-height: 50px;

        i {
          display: inline-block;
          margin-left: 5px;
          font-size: 16px;
        }
      }
    }

    .bord {
      border-bottom: 1px solid rgba(64, 64, 64, 0.24);
    }
  }

  .detali {
    width: 100%;
    height: 202px;
    border-radius: 5px 5px 5px 5px;
    box-shadow: 0px 0px 7px 0px #e5e5e5;
    opacity: 1;
    margin: 15px 0px;
    position: relative;

    .detali_zw {
      width: 100%;
      height: 100%;
      line-height: 360px;
    }

    .detali_let {
      width: 40%;
      height: 100%;
      padding-left: 29px;
      box-sizing: border-box;
      position: relative;

      .newtag {
        position: absolute;
        width: 45px;
        top: 0;
        left: -21px;
        cursor: pointer;
      }

      .newtag2 {
        position: absolute;
        width: 38px;
        top: 55px;
        left: -18px;
        cursor: pointer;
      }

      // margin-right: 120px;
      .hotbq {
        position: absolute;
        top: -5px;
        left: -40px;
        transform: rotate(-45deg);
        -ms-transform: rotate(-45deg);
        /* Internet Explorer */
        -moz-transform: rotate(-45deg);
        /* Firefox */
        -webkit-transform: rotate(-45deg);
        /* Safari 和 Chrome */
        -o-transform: rotate(-45deg);
        /* Opera */
      }

      .detali_let_one {
        .detali_let_one_img {
          width: 126px;
          height: 126px;
          margin: auto;
          position: relative;

          img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
            position: absolute;
            clip: rect(0px 180px 180px 1px);
          }
        }

        .detali_let_one_p {
          width: 100%;

          p {
            width: 100%;
            margin-bottom: 15px;
            font-size: 16px;
          }

          .let_one_p_gj {
            font-size: 14px;
          }
        }
      }

      .detali_r {
        padding-left: 37px;
        box-sizing: border-box;

        // width: 78%;
        .neirongf {
          font-size: 18px;
          width: 100%;
          display: flex;
          position: relative;

          .neirongf_let {
            width: 170px;
            height: 34px;
            margin-bottom: 21px;
            font-size: 16px;
            font-weight: 400;
            color: #000000;
          }

          .neirongf_rig {
            width: 320px;
            height: 36px;
            // line-height: 40px;
            overflow: hidden;
            min-width: calc((100%) / 3);

            .neirongf_rig_p {
              // width: 130px;
              width: calc((100%) / 3);
              min-width: calc((100%) / 3);
              max-width: calc((100%) / 3);
              font-size: 16px;
              height: 34px;
              margin-right: 24px;
            }

            .detali_r_p_img {
              width: calc((100%) / 3);
              min-width: calc((100%) / 3);
              max-width: calc((100%) / 3);
              font-size: 16px;
              height: 34px;
              margin-right: 24px;
            }
          }

          .neirongf_rig_pp {
            width: 320px;
            height: 38px;
            // line-height: 40px;
            overflow: hidden;
            min-width: calc((100%) / 2);

            .neirongf_rig_pplist {
              // width: 130px;
              width: calc((100%) / 2);
              min-width: calc((100%) / 2);
              max-width: calc((100%) / 2);
              font-size: 16px;
              height: 34px;
              // margin-right: 24px;
            }
          }

          .neirongf_rig_log {
            width: 320px;
            height: 38px;
            // line-height: 40px;
            overflow: hidden;
            min-width: calc((100%) / 2);

            .neirongf_rig_p_log {
              // width: 130px;
              width: calc((100%) / 2);
              min-width: calc((100%) / 2);
              max-width: calc((100%) / 2);
              font-size: 16px;
              height: 34px;
            }
          }

          .rigtop1 {
            width: 320px;
            height: 38px;
            // line-height: 40px;
            overflow: hidden;
            min-width: calc((100%) -60px / 3);

            .neirongf_rig_p {
              // width: 130px;
              width: calc((100%) -60px / 3);
              min-width: calc((100%) -60px / 3);
              max-width: calc((100%) -60px / 3);
              font-size: 16px;
              height: 34px;
              margin-right: 24px;
            }
          }

          .neirongf_rugn {
            width: 500px;
            height: 40px;
            overflow: hidden;
          }

          .detali_r_p {
            // width: 126px;
            height: 100%;
            display: inline-block;
            margin-bottom: 0px;
            // margin-right: 34px;
            width: calc((100%) -60px / 3);
            min-width: calc((100%) -60px / 3);
            max-width: calc((100%) -60px / 3);

            img {
              width: 140px;
              height: 30px;
              margin-right: 10px;
              margin-bottom: 10px;
            }
          }

          .neirongf_icon {
            position: absolute;
            right: -10px;

            i {
              color: #be3c6e;
              font-size: 40px;
            }
          }
        }

        .leirong {
          width: 100%;
          padding-right: 20px;
          box-sizing: border-box;
        }

        .detali_r_div {
          font-size: 26px;
          margin-bottom: 16px;
          position: relative;

          div {
            position: absolute;
            left: 150px;
            top: 0;
            width: 100%;
          }

          .detali_r_p {
            width: 126px;
            height: 100%;
            display: inline-block;
            margin-bottom: 0px;
            margin-right: 34px;

            img {
              width: 100%;
              height: 44px;
              margin-right: 33px;
            }
          }
        }
      }
    }

    .detali_cont {
      width: 28%;
      // height: 166px;
      box-sizing: border-box;
      position: relative;
      padding-top: 10px;
      // margin-left: 120px;

      .hotbq {
        position: absolute;
        top: -5px;
        left: -20px;
        transform: rotate(-45deg);
        -ms-transform: rotate(-45deg);
        /* Internet Explorer */
        -moz-transform: rotate(-45deg);
        /* Firefox */
        -webkit-transform: rotate(-45deg);
        /* Safari 和 Chrome */
        -o-transform: rotate(-45deg);
        /* Opera */
      }

      .detali_let_one {
        .detali_let_one_img {
          width: 166px;
          height: 166px;
          margin: auto;
          position: relative;

          img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
            position: absolute;
            clip: rect(0px 180px 180px 1px);
          }
        }

        .detali_let_one_p {
          width: 100%;

          p {
            width: 100%;
            margin-bottom: 15px;
            font-size: 16px;
          }

          .let_one_p_name {
            width: 166px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .let_one_p_gj {
            font-size: 14px;
          }
        }
      }

      .detali_r {
        padding-left: 37px;
        box-sizing: border-box;

        // width: 78%;
        .neirongf {
          font-size: 18px;
          width: 100%;
          display: flex;
          position: relative;

          .neirongf_let {
            width: 170px;
            height: 34px;
            margin-bottom: 21px;
            font-size: 16px;
            font-weight: 400;
            color: #000000;
          }

          .neirongf_rig {
            width: 320px;
            height: 36px;
            // line-height: 40px;
            overflow: hidden;
            min-width: calc((100%) / 3);

            .neirongf_rig_p {
              // width: 130px;
              width: calc((100%) / 3);
              min-width: calc((100%) / 3);
              max-width: calc((100%) / 3);
              font-size: 16px;
              height: 34px;
              margin-right: 24px;
            }

            .detali_r_p_img {
              width: calc((100%) / 3);
              min-width: calc((100%) / 3);
              max-width: calc((100%) / 3);
              font-size: 16px;
              height: 34px;
              margin-right: 24px;
            }
          }

          .neirongf_rig_pp {
            width: 320px;
            height: 38px;
            // line-height: 40px;
            overflow: hidden;
            min-width: calc((100%) / 2);

            .neirongf_rig_pplist {
              // width: 130px;
              width: calc((100%) / 2);
              min-width: calc((100%) / 2);
              max-width: calc((100%) / 2);
              font-size: 16px;
              height: 34px;
              // margin-right: 24px;
            }
          }

          .neirongf_rig_log {
            width: 320px;
            height: 38px;
            // line-height: 40px;
            overflow: hidden;
            min-width: calc((100%) / 2);

            .neirongf_rig_p_log {
              // width: 130px;
              width: calc((100%) / 2);
              min-width: calc((100%) / 2);
              max-width: calc((100%) / 2);
              font-size: 16px;
              height: 34px;
            }
          }

          .rigtop1 {
            width: 320px;
            height: 38px;
            // line-height: 40px;
            overflow: hidden;
            min-width: calc((100%) -60px / 3);

            .neirongf_rig_p {
              // width: 130px;
              width: calc((100%) -60px / 3);
              min-width: calc((100%) -60px / 3);
              max-width: calc((100%) -60px / 3);
              font-size: 16px;
              height: 34px;
              margin-right: 24px;
            }
          }

          .neirongf_rugn {
            width: 500px;
            height: 40px;
            overflow: hidden;
          }

          .detali_r_p {
            // width: 126px;
            height: 100%;
            display: inline-block;
            margin-bottom: 0px;
            // margin-right: 34px;
            width: calc((100%) -60px / 3);
            min-width: calc((100%) -60px / 3);
            max-width: calc((100%) -60px / 3);

            img {
              width: 140px;
              height: 30px;
              margin-right: 10px;
              margin-bottom: 10px;
            }
          }

          .neirongf_icon {
            position: absolute;
            right: -10px;

            i {
              color: #be3c6e;
              font-size: 40px;
            }
          }
        }

        .leirong {
          width: 100%;
          padding-right: 20px;
          box-sizing: border-box;
        }

        .detali_r_div {
          font-size: 26px;
          margin-bottom: 16px;
          position: relative;

          div {
            position: absolute;
            left: 150px;
            top: 0;
            width: 100%;
          }

          .detali_r_p {
            width: 126px;
            height: 100%;
            display: inline-block;
            margin-bottom: 0px;
            margin-right: 34px;

            img {
              width: 100%;
              height: 44px;
              margin-right: 33px;
            }
          }
        }
      }
    }

    .detali_rght {
      width: 22%;
      height: 166px;
      padding-top: 10px;

      .detali_rght_img {
        margin-top: 8px;
        margin-bottom: 5px;

        // padding: 10px 0;
        .detali_rght_one {
          width: 88px;
          height: 88px;
          margin-right: 20px;
          display: flex;
          align-items: center;
          justify-content: center;

          img {
            max-width: 100%;
            max-height: 88px;
          }
        }

        .detali_rght_two {
          margin: 0 10px;

          .detali_rght_two_img {
            margin-bottom: 10px;
            width: 110px;
            height: 110px;
          }

          width: 110px;
          height: 110px;

          img {
            max-width: 110px;
            max-height: 110px;
          }
        }
      }
    }

    .emalis {
      width: 10%;
      justify-content: flex-end;
      // padding-left: 7% !important;
      height: 166px;

      .emalisimg {
        width: 29px;
        height: 29px;
        padding: 1px;

        img {
          width: 100%;
        }
      }

      .emalimag {
        .h22 {
          height: 22px;
        }
      }

      .emalimag2 {
        width: 31px;
        height: 31px;
      }
    }
  }

  .detaliTwo {
    border: 1px solid #e6eaee;
    background: #fff;
  }

  .mgbur {
    margin-bottom: 100px;
  }

  .tit_lrestus {
    background: rgba(166, 168, 191, 0.25);
    border-radius: 5px;
  }

  .allgj {
    padding-left: 25px;
    display: flex;
    justify-items: center;
    align-items: center;

    p {
      height: 24px;
      line-height: 24px;
      padding: 1px 10px;
    }
  }

  .ditels {
    width: 100%;
    height: 300px;
    display: flex;
    position: relative;

    .ditels_img {
      width: 242px;
      height: 242px;
      border-radius: 50%;
      margin-top: 10px;
      margin-right: 100px;

      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }

    .emai {
      position: absolute;
      right: 70px;
      top: 50px;
    }

    .national {
      width: 92px;
      margin-right: 20px;
    }

    .types {
      .types_img1 {
        width: 100px;
        height: 48px;
        border-radius: 50%;
        margin: 0 10px;
        margin-top: -15px;

        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }

      .types_img2 {
        margin-top: -15px;
      }

      .types_img3 {
        margin: 0 10px;
        margin-top: -15px;
      }
    }

    .brand {
      span {
        display: inline-block;
        margin-right: 20px;
      }
    }
  }
}

.grouping {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.1);
  z-index: 9999;

  .top {
    max-width: 615px;
    background: #fff;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-top: -240px;
    margin-left: -340px;

    .top_icon {
      width: 100%;
      text-align: right;
      font-size: 28px;
      padding: 15px 15px 0 0;
    }

    .top_top {
      width: 100%;
      max-height: 320px;
      flex-wrap: wrap;
      overflow: auto;
      padding: 0 43px;

      .top_p {
        width: 140px;
        margin: 0 15px;
        margin-bottom: 8px;

        p {
          width: 100%;
          text-align: center;
          margin-top: 8px;
        }

        .top_img {
          width: 140px;
          height: 124px;
          box-shadow: 0px 5px 6px 1px rgba(0, 0, 0, 0.16);
          border-radius: 20px 20px 20px 20px;
          justify-content: center;
          align-items: center;

          img {
            width: 100px;
            height: 80px;
          }
        }
      }
    }

    .top_top::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      border-radius: 10px;
      background: #be3c6e;
    }

    .top_top::-webkit-scrollbar-track {
      /*滚动条里面轨道*/
      border-radius: 10px;
      background: #ededed;
    }

    .top_top::-webkit-scrollbar {
      /*滚动条整体样式*/
      width: 4px;
      /*高宽分别对应横竖滚动条的尺寸*/
      height: 1px;
    }

    .butt {
      width: 100%;
      margin-top: 30px;

      .button_div {
        width: 96px;
        height: 40px;
        background: #be3c6e;
        border-radius: 5px 5px 5px 5px;
        margin: 0 auto;
        line-height: 40px;
        text-align: center;
        color: #fff;
      }

      .text {
        width: 100%;
        text-align: center;
        color: #707070;
        font-size: 12px;
      }
    }
  }
}

.nologins_title {
  width: 400px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -200px;
  margin-left: -200px;
  background: #fff;
  border-radius: 15px;
  padding: 20px;
}

.nologins_title_imgs {
  width: 320px;
  margin: 0 auto;
  margin-top: 10px;
}

.nolobutt_top {
  justify-content: space-between;
  padding: 0 30px;
}

.nolobutt2 {
  width: 50px;
  height: 30px;
}

.nolobutt {
  width: 70px;
  height: 30px;
  background: #000;
}

.tab_left_select_gj {
  height: 30px;
  align-items: center;
  margin: 15px 0;
}

.nologins {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5, #000);
  z-index: 2;

  .nologins_title {
    width: 400px;
    // height: 400px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -200px;
    margin-left: -200px;
    background: #fff;
    border-radius: 15px;
    padding: 20px;
  }

  .nologins_title_icon {
    width: 100%;
    text-align: right;
    font-size: 26px;
    padding-right: 10px;

    i {
      color: #000;
    }
  }

  .nologins_title_img {
    width: 200px;
    height: 200px;
    margin: 0 auto;
    margin-top: 40px;

    img {
      width: 200px;
      height: 200px;
      display: inline-block;
      margin: 0 auto;
    }
  }

  .nologins_title_text {
    width: 100%;
    margin-top: 20px;
    font-size: 22px;

    div {
      justify-content: space-around;
    }

    .yes {
      width: 100px;
      height: 40px;
      line-height: 40px;
    }

    .no {
      width: 100px;
      height: 40px;
      line-height: 40px;
      border: 1px solid #be3c6e;
    }
  }
}

::v-deep(.el-carousel__container) {
  height: 704px;
}

/* 1.过渡动画 */
@keyframes axisX {
  from {
    transform: translateX(100%);
  }

  to {
    transform: translateX(0px);
  }
}

@keyframes axisX2 {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes axisX3 {
  0% {
    opacity: 0;
  }

  70% {
    opacity: 0;
  }

  80% {
    opacity: 0.7;
  }

  90% {
    opacity: 0.9;
  }

  100% {
    opacity: 1;
  }
}

@keyframes widthX {
  from {
    width: 0px;
  }

  to {
    width: 200px;
  }
}

@keyframes opacityLing {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}

.expire {
  width: calc(100% - 230px);
  height: 50px;
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 1;
  box-sizing: border-box;

  .expire_top {
    position: relative;

    .expire_icon {
      position: absolute;
      right: 35px;

      i {
        font-size: 20px;
      }
    }
  }
}
</style>
<style lang="less">
.cutting {
  .el-table--border,
  .el-table--group {
    border: none;
  }

  .el-table__body {
    -webkit-border-vertical-spacing: 20px; // 垂直间距
  }

  .el-table,
  .el-table__expanded-cell {
    background-color: transparent;
  }

  .pagination-container {
    background: #fafafd !important;
  }

  .pagination-container {
    background: none !important;
  }

  .el-table--border::after,
  .el-table--group::after,
  .el-table::before {
    background: #fafafa;
  }

  .el-table__fixed-right::before,
  .el-table__fixed::before {
    background: #fafafa;
  }

  /* .el-icon-arrow-up:before {
    color: #be3c6e;
  } */
  .unmaeinput {
    .el-input--prefix .el-input__inner {
      border: none;
    }
  }
}

.tab_left_select_gj {
  .el-input--prefix .el-input__inner {
    border: 1px solid;
  }
}

.el-carousel__button {
  width: 25px;
  height: 25px;
  background: #fff;
  border-radius: 50%;
  margin-top: 30px;
  margin: 30px 10px 0 10px;
}

.carouselpp {
  .el-carousel__indicators--outside {
    display: none;
  }
}

.btn-next {
  min-width: 52px !important;
  height: 22px !important;
  font-size: 12px !important;
  text-align: center !important;
  line-height: 22px !important;
  background: rgba(168, 168, 191, 0.25) !important;
  border-radius: 6px 6px 6px 6px !important;
  padding-right: 9.6px;
}

.btn-prev {
  min-width: 52px !important;
  height: 22px !important;
  font-size: 12px !important;
  text-align: center !important;
  line-height: 22px !important;
  background: #e5e6ee !important;
  background: rgba(168, 168, 191, 0.25) !important;
  padding: none !important;
  padding-left: 5px !important;
  padding-left: 9.6px !important;
}

.el-pager {
  margin: 0 15px;
  background: #fafafd;
}

.el-pager li.active {
  background: #e5e6ee;
  color: #000;
  border-radius: 6px;
  margin: 0 5px;
}

.el-pager li {
  background: none;
  font-weight: 400;
}

.pagination-container {
  padding: none !important;
}

.el-pagination .btn-next {
  padding-right: 12px;
}

.el-icon-arrow-up:before {
  content: '';
}

.cent_input {
  .el-input--suffix .el-input__inner {
    padding-left: 30px;
    height: 40px;
  }
}

.el-pagination button:disabled {
  border-radius: 5px;
}

.el-pagination .btn-prev {
  border-radius: 5px;
}

.el-pagination button:hover {
  color: #303133;
}

.el-pager li:hover {
  color: #303133;
}

.el-icon-arrow-up:before {
  content: '';
}

.el-icon-loading {
  font-size: 45px !important;
}
</style>
